export const knowledge = {
  folderGuidelines: {
    exportGuidelines: 'Export Guidelines',
    guidelineResource: 'Guideline',
    guidelinesFolder: 'guidelines folder',
    thisActionCannotBeUndone:
      'This action cannot be undone. The guideline will be permanently deleted.',
  },
  guidelines: {
    category: {
      brandAssets: 'Brand Assets',
      contentStyle: 'Content Style',
      technicalRequirements: 'Technical Requirements',
      textCorrectness: 'Text Correctness',
      textFormatting: 'Text Formatting',
    },
    categoryFilterHead: {
      filterByCategory: 'Filter by category',
    },
    categoryFilterMenu: {
      category: 'Category',
      clear: 'Clear',
    },
    createFolderModal: {
      cancel: 'Cancel',
      createFolder: 'Create folder',
      createGuidelineFolder: 'Create Guideline Folder',
      creating: 'Creating...',
      description: 'Description',
      eGCoreGuidelines: 'e.g. Core Guidelines',
      eGSetOfGeneral: 'e.g. Set of general guidelines used across all campaigns',
      name: 'Name',
    },
    createGuidelineModal: {
      maxSizeIs: 'Max size is {{maxSizeMb}} MB',
      unsupportedFileType: 'Unsupported file type: {{fileNames}}.',
      addGuideline: 'Add Guideline',
      cancel: 'Cancel',
      category: 'Category',
      createManually: 'Create Manually',
      description: 'Description',
      dragAndDropFilesHere: 'Drag and drop files here, or click to select files',
      generateWithAi: 'Generate with AI',
      import: 'Import',
      saveChanges: 'Save changes',
      saving: 'Saving...',
      pleaseUploadFilesOnly: 'Please upload {{formats}} files only.',
      uploadedFiles: 'Uploaded files ({{fileCount}})',
      eGAlwaysUseActive:
        'e.g. Always use active voice in marketing copy for clarity and engagement',
      eGUseActiveVoice: 'e.g. Use Active Voice',
      importFromDocument: 'Import From Document',
      mixedFileTypes:
        'Please upload either text files (.txt, .md) for import, or image/PDF files for AI generation, but not both.',
      name: 'Name',
      removeFile: 'Remove {{fileName}}',
      selectCategory: 'Select category',
    },
    editFolderModal: {
      cancel: 'Cancel',
      delete: 'Delete',
      description: 'Description',
      editGuidelineFolder: 'Edit Guideline Folder',
      enterFolderDescription: 'Enter folder description',
      enterFolderName: 'Enter folder name',
      guidelineFolder: 'Guideline Folder',
      name: 'Name',
      saveChanges: 'Save changes',
      saving: 'Saving...',
      thisActionCannotBeUndone:
        'This action cannot be undone. All guidelines inside this folder will also be permanently deleted.',
    },
    editGuidelineModal: {
      cancel: 'Cancel',
      category: 'Category',
      description: 'Description',
      editGuideline: 'Edit Guideline',
      eGAlwaysUseActive:
        'e.g. Always use active voice in marketing copy for clarity and engagement',
      eGUseActiveVoice: 'e.g. Use Active Voice',
      name: 'Name',
      saveChanges: 'Save changes',
      saving: 'Saving...',
      selectCategory: 'Select category',
    },
    emptyFoldersList: {
      createGuidelineFolder: 'Create Guideline Folder',
      organizeYourBrandAndVisual:
        'Organize your brand and visual guidelines into folders to keep them structured and easy to manage. Each folder can contain multiple guidelines that define your brand standards.',
      startCreatingYourFirstGuideline: 'Start creating your first guideline folder',
      youDonTHavePermission: "You don't have permission to manage guidelines",
    },
    emptyGuidelinesList: {
      addGuideline: 'Add Guideline',
      clickOnAddGuidelinesTo:
        'Click on "Add Guidelines" to start adding guidelines to your Sentinel tool.',
      noGuidelineAddedYet: 'No guideline added yet',
      noGuidelinesMatchYourSearch: 'No guidelines match your search or filters.',
      tryAdjustingYourSearchOrFilters: 'Try adjusting your search or filters.',
      youDonTHavePermission: "You don't have permission to manage guidelines",
    },
    expandableDescription: {
      showLess: 'Show less',
      showMore: 'Show more',
    },
    folderCard: {
      guidelineCount_one: '{{count}} guideline',
      guidelineCount_other: '{{count}} guidelines',
      lastModified: 'Last modified {{date}}',
    },
    folderFormSheet: {
      createDescription: 'Group related guidelines into a folder.',
      createTitle: 'New guideline folder',
      editDescription: "Update this folder's name and description.",
    },
    folderGuidelinesPane: {
      backToFolders: 'Back to guideline folders',
      folderUnavailable: 'Folder unavailable',
      selectAFolder: 'Select a folder',
    },
    folderIdentity: {
      editFolder: 'Edit folder',
    },
    foldersList: {
      noResultsForPleaseCheck:
        'No results for "{{search}}". Please check your search query and try again.',
      noSearchResults: 'No search results',
    },
    foldersToolbar: {
      createGuidelineFolder: 'Create Guideline Folder',
      guidelinesFolders: 'Guidelines Folders',
      searchFolder: 'Search folder...',
      youDonTHavePermission: "You don't have permission to manage guidelines",
    },
    guidelineActionMenu: {
      delete: 'Delete',
      edit: 'Edit',
      guidelineActions: 'Guideline actions',
      youDonTHavePermission: "You don't have permission to manage guidelines",
    },
    guidelineFolderInfoPopover: {
      created: 'Created',
      folderInfo: 'Folder info',
      lastModified: 'Last modified',
      unknown: 'Unknown',
    },
    guidelineFoldersPanel: {
      noFoldersYet: 'No guideline folders yet',
    },
    guidelineFormSheet: {
      removeFile: 'Remove file',
      textFileFormat: 'Importing TXT or MD files',
      textFileFormatDescription:
        'Write each guideline in this format, with a blank line between guidelines, and it is imported exactly as written. Files in any other layout are read by AI instead, so review the guidelines it creates.',
      validCategories: 'Category must be one of: {{categories}}.',
    },
    guidelineRowActions: {
      guidelineActions: 'Guideline actions',
    },
    guidelinesHeader: {
      brandVisualGuidelines: 'Brand & visual guidelines',
      knowledge: 'Knowledge',
    },
    guidelinesTable: {
      actions: 'Actions',
      addedAt: 'Added at',
      category: 'Category',
      description: 'Description',
      name: 'Name',
    },
    guidelinesToolbar: {
      addGuideline: 'Add guideline',
      guidelines: 'Guidelines',
      searchGuideline: 'Search guideline...',
      searchGuidelineLabel: 'Search guideline',
      youDonTHavePermission: "You don't have permission to manage guidelines",
    },
    useCreateFolder: {
      failedToCreateFolder: 'Failed to create folder',
      folderCreated: '"{{title}}" folder created',
    },
    useCreateGuideline: {
      failedToCreateGuideline: 'Failed to create guideline',
      guidelineCreated: '"{{name}}" guideline created',
    },
    useDeleteFolder: {
      failedToDeleteFolder: 'Failed to delete folder',
      folderDeleted: '"{{title}}" folder deleted successfully',
      folderDeletedSuccessfully: 'Folder deleted successfully',
    },
    useDeleteGuideline: {
      failedToDeleteGuideline: 'Failed to delete guideline',
      guidelineDeleted: '"{{name}}" guideline deleted',
      guidelineDeletedSuccessfully: 'Guideline deleted successfully',
    },
    useExportFolderGuidelines: {
      failedToExportGuidelines: 'Failed to export guidelines',
    },
    useGenerateGuidelinesFromFiles: {
      failedToImportGuidelines: 'Failed to import guidelines',
      guidelinesImported_one: '{{count}} guideline imported successfully',
      guidelinesImported_other: '{{count}} guidelines imported successfully',
      noGuidelinesGenerated: 'No guidelines could be generated from the uploaded files',
    },
    useImportGuidelinesFromFiles: {
      failedToImportGuidelines: 'Failed to import guidelines',
      guidelinesImported_one: '{{count}} guideline imported successfully',
      guidelinesImported_other: '{{count}} guidelines imported successfully',
      noGuidelinesImported: 'No guidelines could be imported from the uploaded files',
    },
    useUpdateFolder: {
      failedToUpdateFolder: 'Failed to update folder',
      folderUpdated: '"{{title}}" folder updated',
    },
    useUpdateGuideline: {
      failedToUpdateGuideline: 'Failed to update guideline',
      guidelineUpdated: '"{{name}}" guideline updated',
    },
    workspaceIdIsRequired: 'Workspace ID is required',
  },
  knowledgeBase: {
    knowledgeBase: 'Knowledge Base',
  },
  knowledgeBaseDetail: {
    clickOnAddDocumentsTo:
      "Click on 'Add Documents' to start adding documents to your knowledge base.",
    documentDetail: 'Document Detail',
    documentResource: 'Document',
    downloadingDocuments: 'Downloading {{documentCount}} documents.',
    downloadStarted: 'Download started.',
    failedToDownloadFile: 'Failed to download file',
    failedToDownloadTheSelected: 'Failed to download the selected documents.',
    noDocumentsAddedYet: 'No documents added yet',
    noDocumentsMatchYourSearch: 'No documents match your search.',
    thisActionIsIrreversibleBy:
      'This action is irreversible, by confirming this document will permanently be removed from this knowledge base.',
    uploadFilesTo: 'Upload Files to {{name}}',
  },
  knowledgeBases: {
    emptyKnowledgeBaseList: {
      create: 'Create',
      knowledgeBasesGiveStructureTo:
        'Knowledge bases give structure to your knowledge by grouping documents in groups for organized, efficient knowledge management.',
      startCreatingYourFirstKnowledge: 'Start creating your first knowledge base',
    },
    fileDetail: {
      addedAt: 'Added At',
      addedBy: 'Added By',
      description: 'Description',
      noTags: 'No tags',
      tags: 'Tags',
      unknown: 'Unknown',
    },
    fileUploadStore: {
      allUploadsFailed: 'All uploads failed',
      failedToProcess: '{{fileName}} failed to process',
      knowledgeBaseIdRequiredForUpload: 'Knowledge Base ID is required for upload',
    },
    fileUploader: {
      addDocuments: 'Add Documents',
      cancel: 'Cancel',
      ourIntelligenceWillAnalyzeAnd:
        'Our intelligence will analyze and extract all relevant content of your document',
      removeFile: 'Remove {{fileName}}',
      uploadDocument: 'Upload Document',
    },
    kbMultiSelectWidget: {
      knowledgeBasesSelected: '{{selected}}/{{max}} knowledge bases selected',
      maximumReached: ' (maximum reached)',
      noKnowledgeBasesFound: 'No knowledge bases found',
      notVisibleHere_one:
        '{{count}} more selected from another workspace. Not listed here, and kept when you save.',
      notVisibleHere_other:
        '{{count}} more selected from another workspace. Not listed here, and kept when you save.',
      reduceToSave: ' - reduce to save',
      removeKnowledgeBase: 'Remove {{name}}',
      selectKnowledgeBases: 'Select knowledge bases',
    },
    kbSelectWidget: {
      none: 'None',
    },
    collectionFormSheet: {
      createDescription: 'Give your new collection a title, a description and a space visibility.',
      editTitle: 'Edit {{name}} collection',
    },
    collectionFilesPane: {
      backToCollections: 'Back to collections',
      collectionUnavailable: 'This collection is unavailable',
      noFilesYet: 'No files yet',
      noFilesYetDescription: 'Upload a file to start building this collection.',
    },
    collectionFilesToolbar: {
      searchFiles: 'Search files...',
      searchFilesLabel: 'Search files',
      uploadFile: 'Upload file',
    },
    collectionPaneHeader: {
      editCollection: 'Edit collection',
      foundationVisibility: 'Foundation knowledge, visible across all organizations',
      organizationVisibility: 'Collection visible to everyone in the organization',
      sharedWorkspacesVisibility: 'Collection visible only in the workspaces it is shared with',
      workspaceVisibility: 'Collection visible only to this workspace',
    },
    collectionsRailToggle: {
      hideCollections: 'Hide collections',
      showCollections: 'Show collections',
    },
    collectionsPanel: {
      all: 'All',
      collections: 'Collections',
      filterByVisibility: 'Filter by visibility',
      filterCollections: 'Filter collections',
      foundation: 'Foundation',
      newCollection: 'New collection',
      noCollectionsInThisSpace: 'No collections in this space',
      noCollectionsYet: 'No collections yet',
      noCollectionsYetDescription: 'Create a collection to start organizing your files.',
      organization: 'Organization',
      workspace: 'Workspace',
      workspacesCount: '{{count}} workspaces',
    },
    knowledgeBaseDeleteForm: {
      thisActionIsIrreversibleBy:
        'This action is irreversible. By confirming this action, all agents that consult documents present in this knowledge base will have their responses affected.',
    },
    knowledgeBaseDownload: {
      bulkDownloadLimit:
        'Bulk download is limited to {{max}} files at a time. Please narrow your selection.',
      noDownloadableFiles: 'No downloadable files in the current selection.',
    },
    knowledgeBaseDetailInfo: {
      createdBy: 'Created By',
      foundation: 'Foundation',
      lastModified: 'Last modified',
      now: 'Now',
      spaceVisibility: 'Space Visibility',
    },
    knowledgeBaseInfoPopover: {
      collectionInfo: 'Collection info',
      createdBy: 'Created by',
      lastModified: 'Last modified',
      sharedWith: 'Shared with',
      sharedWithHidden_one: '+1 workspace you cannot access',
      sharedWithHidden_other: '+{{count}} workspaces you cannot access',
      unknown: 'Unknown',
    },
    knowledgeBaseDocumentRowActions: {
      delete: 'Delete',
      documentActions: 'Document actions',
      download: 'Download',
      viewDetail: 'View Detail',
    },
    knowledgeBaseDocumentsHeader: {
      onlyAdministratorsCanAdd:
        'Only {{visibility}} administrators can add documents to this knowledge base',
      addDocuments: 'Add Documents',
      clearSearch: 'Clear search',
      documents: 'Documents ({{documentCount}})',
      searchDocuments: 'Search documents...',
      searchDocuments2: 'Search documents',
    },
    knowledgeBaseDocumentsTable: {
      actions: 'Actions',
      addedAt: 'Added At',
      addedBy: 'Added By',
      additionalTagsCount: '+{{count}}',
      clickOnAddDocumentsTo:
        "Click on 'Add Documents' to start adding documents to your knowledge base.",
      document: 'document',
      name: 'Name',
      noDocumentsAddedYet: 'No documents added yet',
      noTypeAssigned: 'No type assigned',
      selectAllDocumentsOnThis: 'Select all documents on this page',
      selectDocument: 'Select {{name}}',
      type: 'Type',
      status: {
        completed: 'Completed',
        failed: 'Failed',
        pending: 'Pending',
        skipped: 'Skipped',
        uploading: 'Uploading',
      },
      tags: 'Tags',
      theSourceForThisFile: 'The source for this file is not available',
      unknown: 'Unknown',
      untitled: 'Untitled',
      uploadedAt: 'Uploaded at',
      uploadedBy: 'Uploaded by',
    },
    knowledgeBaseForm: {
      cancel: 'Cancel',
      createKnowledgeBase: 'Create Knowledge Base',
      createKnowledgeBaseForm: 'Create knowledge base form',
      delete: 'Delete',
      editKnowledgeBase: 'Edit Knowledge Base',
      editKnowledgeBaseForm: 'Edit knowledge base form',
      newKnowledgeBase: 'New Knowledge Base',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
    },
    knowledgeBaseFormDescription: {
      description: 'Description',
      eGBrandSPurpose:
        "e.g: Brand's purpose, mission, values, strategic positioning, engagement tactics",
      giveADescriptionToExplain:
        'Give a description to explain the types of document found on this knowledge base',
    },
    knowledgeBaseFormField: {
      requiredField: 'required field',
    },
    knowledgeBaseFormSpaceVisibility: {
      onlyAgentsInSelectedWorkspaces:
        'Only agents in the selected workspaces will have access to this knowledge base.',
      setTheSpaceVisibilityTo: 'Set the space visibility to the agents of your knowledge base',
      spaceVisibility: 'Space Visibility',
    },
    knowledgeBaseFormTitle: {
      eGBrandIdentity: 'e.g: Brand Identity',
      giveAShortAndClear: 'Give a short and clear title to help identify the knowledge base',
      title: 'Title',
    },
    knowledgeFilesHeader: {
      knowledge: 'Knowledge',
      knowledgeFiles: 'Knowledge files',
    },
    knowledgeFilesAbout: {
      title: 'About knowledge files',
      description:
        'Collections of files that feed Monks.Flow agents, so they work from your context instead of general knowledge.',
      groupFiles: 'Group related files into a collection, one per brand, client, or subject.',
      feedAgents:
        'Agents draw on the collections they are given, expanding what they know about your work.',
      chooseReach:
        'Choose who each collection reaches: your whole organization, a single workspace, or foundation knowledge shared across organizations.',
    },
    knowledgeBaseHeader: {
      onlyAdministratorsCanEdit: 'Only {{visibility}} administrators can edit this knowledge base',
      backToKnowledgeBases: 'Back to Knowledge Bases',
      backToKnowledgeHub: 'Back to Knowledge Hub',
      buildYourBrandsKnowledgeBase:
        "Build your brand's comprehensive knowledge base used by agents.",
      editKnowledgeBase: 'Edit Knowledge Base',
      loadingDetails: 'Loading knowledge base details...',
      noDescriptionAvailable: 'No description available.',
    },
    knowledgeBaseItem: {
      documentCount_one: '{{count}} Document',
      documentCount_other: '{{count}} Documents',
      foundationKnowledge: 'Foundation Knowledge',
      lastModified: 'Last modified {{date}}',
    },
    knowledgeBaseList: {
      noResultsForPleaseCheck:
        'No results for "{{search}}". Please check your search query and try again.',
      noSearchResults: 'No search results',
    },
    knowledgeBasesApi: {
      emptyFileListResponse: 'Empty response from getKnowledgeBaseById',
      failedToDeleteFile: 'Failed to delete file from knowledge base: {{reason}}',
      failedToGetFiles: 'Failed to get knowledge base by id: {{reason}}',
      failedToUploadFiles: 'Failed to upload files to knowledge base: {{reason}}',
      knowledgeBaseIdRequired: 'Knowledge base ID is required',
      unknownError: 'Unknown error',
      uploadFailedEmptyResponse: 'Empty response from uploadFiles',
    },
    parseUploadResponse: {
      unknownError: 'Unknown error',
      uploadFailed: 'Upload failed: {{message}}',
    },
    useKbVisibilityOptions: {
      foundationKnowledge: 'Foundation Knowledge',
      foundationKnowledgeAccess:
        'Shared knowledge layer with reusable intelligence across all organizations. Not visible to users, but securely accessible to configured agents.',
      organization: 'Organization',
      organizationAccess:
        'All agents under {{organizationName}} organization will have access to this knowledge base',
      specifiedWorkspaces: 'Specified workspaces',
      specifiedWorkspacesAccess:
        'Only agents under the workspaces you choose will have access to this knowledge base',
      workspace: 'Workspace',
      workspaceAccess:
        'Only agents under {{workspaceName}} workspace will have access to this knowledge base',
      your: 'your',
    },
    useKnowledgeBaseActions: {
      sharingWasNotUpdated: 'Knowledge base saved, but sharing was not updated',
      sharingWasNotUpdatedHint:
        'Your changes to who can access it were not applied. Check the selected workspaces and try again.',
    },
    useKnowledgeBaseFileActions: {
      deleteFailed: 'Delete failed',
      documentDeletedSuccessfully: 'Document deleted successfully',
      fileIdIsRequired: 'File ID is required',
      uploadFailed: 'Upload failed',
    },
    useKnowledgeBaseForm: {
      descriptionIsRequired: 'Description is required',
      descriptionMustBe200Characters: 'Description must be 200 characters or less',
      organizationInformationIsMissingPlease:
        'Organization information is missing. Please refresh and try again.',
      titleIsRequired: 'Title is required',
      titleMustBe50Characters: 'Title must be 50 characters or less',
    },
    knowledgeBasesActions: {
      all: 'All',
      create: 'Create',
      filterBySpaceVisibility: 'Filter by space visibility',
      foundationKnowledge: 'Foundation Knowledge',
      lastModified: 'Last Modified',
      organizationKnowledge: 'Organization Knowledge',
      searchKnowledgeBase: 'Search knowledge base...',
      workspaceKnowledge: 'Workspace Knowledge',
    },
    knowledgeBaseSelectionBar: {
      allSelectedAcrossPages_one: 'All {{count}} document selected across all pages',
      allSelectedAcrossPages_other: 'All {{count}} documents selected across all pages',
      allSelectedOnPage_one: 'All {{count}} document are selected on this page',
      allSelectedOnPage_other: 'All {{count}} documents are selected on this page',
      clearSelection: 'Clear selection',
      documentsSelected_one: '{{count}} document selected',
      documentsSelected_other: '{{count}} documents selected',
      download: 'Download',
      selectAllAcrossPages_one: 'Select all {{count}} document across all pages',
      selectAllAcrossPages_other: 'Select all {{count}} documents across all pages',
    },
  },
  knowledgeHub: {
    briefSectionConfigFields: {
      minimumDate: 'Minimum date',
      maximumDate: 'Maximum date',
      boundWithDate: '{{bound}}: {{date}}',
      noMinimum: 'No minimum',
      noMaximum: 'No maximum',
      today: 'Today',
      specificDate: 'Specific date',
      dateRangeHint: "Whoever fills in the brief can't pick a date outside this range.",
      addOption: 'Add option',
      dragOption: 'Drag option {{index}}',
      optionLabel: 'Option label',
      defaultFalseLabel: 'No',
      defaultTrueLabel: 'Yes',
      falseLabel: 'Label for "no"',
      format: 'Format',
      formatStartAndEndDate: 'Start + End date',
      formatStartDateOnly: 'Start date only',
      allowedFileTypes: 'Allowed file types',
      fileTypeGroups: {
        excel: 'Excel',
        images: 'Images',
        pdf: 'PDF',
        powerpoint: 'PowerPoint',
        video: 'Video',
        word: 'Word',
      },
      maxFileSize: 'Maximum file size (MB)',
      maxFileSizeHint: 'Up to {{max}} MB per file',
      maxCount: 'Maximum number of files',
      maxLength: 'Maximum length',
      optionPlaceholder: 'Option {{index}}',
      options: 'Options',
      removeOptionNamed: 'Remove option {{index}}',
      trueLabel: 'Label for "yes"',
    },
    briefSectionDrawer: {
      addDescription: 'Add a description',
      aiAllowed: 'AI allowed',
      aiAllowedDescription: 'AI can generate content to auto-fill this section',
      aiInstructions: 'AI instructions',
      aiInstructionsPlaceholder: 'Tell AI what to write for this section',
      aiInstructionsRequired:
        'AI instructions are required when AI is allowed to fill this section.',
      allowFiles: 'Files upload allowed',
      allowFilesDescription: 'Files can be attached to this section',
      close: 'Close',
      description: 'Description',
      descriptionHelper: 'Shown as helper text to guide whoever fills this section.',
      enterSectionName: 'Enter section name',
      name: 'Name',
      newSection: 'New section',
      required: 'Required field',
      requiredDescription: 'The brief cannot be sent until this section is filled in.',
      save: 'Save',
      untitled: 'Untitled',
    },
    briefSectionRow: {
      deleteSection: 'Delete section',
      dragSection: 'Drag section {{name}}',
      editSection: 'Edit section',
      newSection: 'New section',
      notSaved: 'Not saved',
      sectionActionsNamed: 'Actions for section {{name}}',
      untitled: 'Untitled',
    },
    briefSectionsBlock: {
      actions: 'Actions',
      add: 'Add',
      aiAllowed: 'AI allowed',
      briefSections: 'Brief sections',
      briefTemplateSections: 'Brief template sections',
      clickAddToStartBuilding: 'Click “Add” to start building this template.',
      description: 'Description',
      noBriefSectionsAddedYet: 'No brief sections added yet',
      reorder: 'Reorder',
      requiredField: 'Required field',
      sectionName: 'Section name',
      thisSectionWillBeRemoved:
        "This section will be removed when you save the template. You can't undo this.",
    },
    briefSectionTypePicker: {
      addBriefSection: 'Add brief section',
      selectTheTypeOfContent: 'Select the type of content this section should collect.',
      boolean: { hint: 'A two-state answer with labels you choose.', label: 'Yes / no' },
      checklist: { hint: 'Several options from a list you define.', label: 'Check list' },
      date: { hint: 'A start date, or a start and end date.', label: 'Date' },
      file: { hint: 'One or more uploads, limited by type, size and count.', label: 'File' },
      select: { hint: 'One option from a list you define.', label: 'Select' },
      text: { hint: 'Free text, with an optional character limit.', label: 'Text' },
      url: { hint: 'A single URL.', label: 'Link' },
    },
    briefTemplateBuilder: {
      readOnlyNotice:
        "You can view this template but not change it. Templates at this level need a permission you don't have.",
      backToBriefTemplates: 'Back to brief templates',
      backToBriefTemplatesList: 'Back to brief templates list',
      briefTemplate: 'brief template',
      briefTemplates: 'Brief Templates',
      deleteTemplate: 'Delete template',
      editDetails: 'Edit details',
      lastModified: 'Last modified',
      lastPublished: 'Last published',
      noBriefTemplateSelected: 'No brief template selected.',
      preview: 'Preview',
      publish: 'Publish',
      published: 'Published',
      publishing: 'Publishing…',
      retry: 'Retry',
      save: 'Save',
      templateActions: 'Template actions',
      unpublishedChanges: 'Unpublished changes',
      weCouldnTLoadThis: "We couldn't load this brief template.",
    },
    briefTemplateDetailsDrawer: {
      addATemplateDescription: 'Add a template description',
      addATemplateName: 'Add a template name',
      close: 'Close',
      description: 'Description',
      save: 'Save',
      templateDetails: 'Template details',
      title: 'Title',
    },
    briefTemplateComingSoon: {
      backToTemplatesList: 'Back to templates list',
      createNewBriefTemplate: 'Create new brief template',
      editBriefTemplate: 'Edit brief template',
      theBriefTemplateEditorIs: 'The brief template editor is coming in a future release.',
      thisEditorIsComingSoon:
        'This editor is coming soon. The brief template editor will be available in a future release.',
    },
    briefTemplatePreviewEmptyState: {
      noBriefSectionsAddedYet: 'No brief sections added yet',
      sectionsWillAppearHereOnce: 'Sections will appear here once added.',
    },
    briefTemplatePreviewPanel: {
      attentionThisIsDummyContent: 'Attention: This is dummy content',
      closeTemplatePreview: 'Close template preview',
      selectPlaceholder: 'Select an option',
      templatePreview: 'Template preview',
    },
    briefTemplatesActionMenu: {
      promoteToOrganization: 'Promote to organization',
      turnOff: 'Turn off',
      turnOn: 'Turn on',
      briefTemplateActions: 'Brief template actions',
      delete: 'Delete',
      duplicate: 'Duplicate',
      edit: 'Edit',
      thisActionCannotBeUndone: 'This action cannot be undone.',
    },
    briefTemplateLevelBadge: {
      organization: 'Organization',
      systemDefault: 'System default',
      workspace: 'Workspace',
    },
    briefTemplateLevelMutations: {
      failedToPromoteTemplate: 'Failed to promote template',
      failedToTurnOffTemplate: 'Failed to turn off template',
      failedToTurnOnTemplate: 'Failed to turn on template',
      templatePromoted: 'Template promoted to organization',
      templateTurnedOff: 'Template turned off',
      templateTurnedOn: 'Template turned on',
      turnedOffByPlatform:
        'This system default is turned off for every organization by the platform, so it stays off until the platform turns it back on.',
    },
    briefTemplateStatusBadge: {
      off: 'Off',
    },
    briefTemplatePromoteDialog: {
      cancel: 'Cancel',
      description:
        '{{name}} will be available in every workspace of your organization, including new ones. This cannot be undone.',
      promote: 'Promote',
      title: 'Promote to organization?',
    },
    briefTemplateOrganizationConfirm: {
      sectionDeleteWarning:
        'This template is used by every workspace in your organization, so the section is removed from all of them.',
      templateDeleteWarning:
        'This template is used by every workspace in your organization, so deleting it removes it from all of them. This action cannot be undone.',
      cancel: 'Cancel',
      continue: 'Continue',
      description:
        'This template is used by every workspace in your organization. Changes apply to all of them.',
      title: 'Change an organization template?',
    },
    briefTemplateLevelChoice: {
      availableIn: 'Available in',
      organizationDescription: 'Every workspace in your organization',
      workspaceDescription: 'Only this workspace',
    },
    briefTemplateTurnOffDialog: {
      cancel: 'Cancel',
      description:
        '{{name}} will no longer be offered in brief creation in any organization. Organizations cannot turn it back on themselves.',
      title: 'Turn off for every organization?',
      turnOff: 'Turn off',
    },
    briefTemplatesConstants: {
      briefTemplates: 'Brief templates',
      createAndManageYourBrief: 'Create and manage your brief templates',
    },
    briefTemplatesEmptyState: {
      newTemplate: 'New template',
    },
    briefTemplatesErrorState: {
      couldnTLoadBriefTemplates: "Couldn't load brief templates",
      retry: 'Retry',
      somethingWentWrongPleaseTry: 'Something went wrong. Please try again.',
    },
    briefTemplatesHeader: {
      knowledge: 'Knowledge',
    },
    briefTemplatesList: {
      backToKnowledgeHub: 'Back to Knowledge Hub',
      newTemplateCreated: 'New template created',
    },
    briefTemplatesNoResultsState: {
      clearFilters: 'Clear filters',
      tryOtherFilters: 'Try other filters or a different search term.',
      clearSearch: 'Clear search',
      noMatchingTemplates: 'No matching templates',
      tryADifferentSearchTerm: 'Try a different search term.',
    },
    briefTemplatesTable: {
      level: 'Level',
      actions: 'Actions',
      createdBy: 'Created by',
      lastModified: 'Last modified',
      name: 'Name',
      status: 'Status',
    },
    emailTemplatesActionMenu: {
      delete: 'Delete',
      emailTemplateActions: 'Email template actions',
      rename: 'Rename',
      thisActionCannotBeUndone:
        'This action cannot be undone. The template will be permanently deleted.',
    },
    emailTemplatesHeader: {
      knowledge: 'Knowledge',
    },
    emailTemplatesList: {
      backToKnowledgeHub: 'Back to Knowledge Hub',
      clearSearch: 'Clear search',
      description: 'Configure the email templates the AI writes content into.',
      emailTemplates: 'Email Templates',
      noMatchingTemplates: 'No matching templates',
      tryADifferentSearchTerm: 'Try a different search term.',
    },
    emailTemplatesTable: {
      actions: 'Actions',
      dateModified: 'Date modified',
      name: 'Name',
    },
    emailTemplatesToolbar: {
      newEmailTemplate: 'New email template',
      searchEmailTemplates: 'Search email templates',
      searchTemplatesByName: 'Search templates by name…',
    },
    briefTemplatesToolbar: {
      allLevels: 'All levels',
      allStatuses: 'All statuses',
      draft: 'Draft',
      level: 'Level',
      off: 'Off',
      published: 'Published',
      status: 'Status',
      newTemplate: 'New template',
      searchTemplatesByName: 'Search templates by name…',
      searchTemplatesLabel: 'Search brief templates',
    },
    knowledgeHubLayout: {
      backToKnowledgeHub: 'Back to Knowledge Hub',
    },
    knowledgeHubCard: {
      view: 'View',
    },
    knowledgeHub: {
      about: {
        description:
          'Ground every tool in your brand so the work comes back on-message the first time.',
        groundAgents:
          'Give agents the files, audiences, and guidelines they need to stay on-brand.',
        reuseContext: 'Reuse approved context instead of re-explaining your brand every time.',
        singleSource: 'Keep everyone working from the same, up-to-date source of truth.',
        title: 'About knowledge',
      },
      audienceCount_one: 'audience',
      audienceCount_other: 'audiences',
      audiences: 'Audiences',
      audiencesDescription:
        'Audience personas built from real needs, behaviors and expectations, for validating ideas and informing other tools.',
      brandMedia: 'Brand Assets',
      brandMediaDescription:
        "The brand's own photography, footage and typefaces in one library, organised into folders.",
      brandVisualGuidelines: 'Brand & visual guidelines',
      brandVisualGuidelinesDescription:
        'Brand and visual rules Sentinel checks every design and message against.',
      briefTemplates: 'Brief templates',
      briefTemplatesDescription:
        'Reusable templates that keep every project brief structured and complete, so creative teams can act on them sooner.',
      collectionCount_one: 'collection',
      collectionCount_other: 'collections',
      emailTemplates: 'Email templates',
      emailTemplatesDescription:
        'Email templates and content sets the Templates Agent builds on-brand campaigns from.',
      folderCount_one: 'folder',
      folderCount_other: 'folders',
      itemCount_one: 'item',
      itemCount_other: 'items',
      knowledge: 'Knowledge',
      knowledgeFiles: 'Knowledge files',
      knowledgeFilesDescription:
        "Documents and files your tools draw on to ground their outputs in your brand's own documentation.",
      mediaGuidelines: 'Media guidelines',
      mediaGuidelinesDescription:
        "Naming, budget and platform standards Delivery's pre-flight QA checks every media plan against.",
      paidMediaAdIntelligence: 'Paid media & ad intelligence',
      paidMediaDescription:
        'Ad platforms and data providers feeding campaign performance, audience and competitor insights.',
      sourceCount_one: 'source',
      sourceCount_other: 'sources',
      standardCount_one: 'standard',
      standardCount_other: 'standards',
      taxonomyAdministration: 'Taxonomy administration',
      templateCount_one: 'template',
      templateCount_other: 'templates',
      yourBrandSComprehensiveKnowledge: "Your brand's comprehensive knowledge hub used by tools",
    },
  },
  dataSource: {
    pathmatics: {
      label: 'Pathmatics',
      description:
        'Competitive ad spend and creative intelligence for the Media and Creative Landscape views.',
      category: 'Media Intelligence',
      uploadHint: 'Upload your CSV to create a brand-specific media spend table',
    },
    statista: {
      label: 'Statista',
      description: 'Market, industry and consumer statistics.',
      connectedHint: 'Reports will be able to draw on this source once the integration is live.',
      disconnectedHint:
        'Connect this source to make it available to reports once the integration is live.',
      disconnectDescription:
        'You can reconnect it at any time. Nothing in your existing reports changes.',
    },
    yougov: {
      label: 'YouGov',
      description: 'Consumer opinion and brand-tracking data for the Marketing Performance view.',
      category: 'Market Research',
      uploadHint: 'Upload your CSV to create a brand-specific research table',
    },
    activate: 'Connect',
    activating: 'Connecting',
    connected: 'Connected',
    connectionOptions: 'Connection options',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect {{name}}?',
    disconnectDescription:
      'Reports can no longer attach new {{name}} files until you reconnect it. Data already attached to existing reports is unaffected.',
    enabledHint:
      'Reports can attach a file from this source. Open a report and use its data sources panel.',
    disabledHint: 'Connect this source to let reports attach a file from it.',
    sectionTitle: 'Research & Intelligence',
    sectionDescription:
      'Upload exports from research and intelligence providers to enrich IQ reports.',
    cancel: 'Cancel',
    listFailed: 'Could not load the data sources',
    activateFailed: 'Could not connect {{name}}',
    deactivateFailed: 'Could not disconnect {{name}}',
  },
  mediaConnector: {
    types: {
      authMethod: {
        oauth: 'OAuth',
        serviceAccount: 'Service Account',
        systemUserToken: 'System User Token',
      },
      authMethodDescription: {
        oauth: 'Sign in with your personal account via the platform login page.',
        serviceAccount: 'Upload a JSON key file from Google Cloud Console.',
        systemUserToken: 'Paste a non-expiring token generated in Meta Business Manager.',
      },
      capability: {
        publishing: 'Publishing',
        reporting: 'Reporting',
        signIn: 'Sign-in',
      },
      capabilityState: {
        failing: 'Failing',
        ok: 'Working',
        unknown: 'Not checked',
      },
      category: {
        adServing: 'Ad Serving',
        programmatic: 'Programmatic (DSP)',
        retailMedia: 'Retail Media',
        searchSocial: 'Search & Social',
      },
      categoryDescription: {
        adServing: 'Ad servers that traffic creative and measure delivery across every channel.',
        programmatic: 'Demand-side platforms for programmatic display, video, and audio buying.',
        retailMedia: 'Retail media networks and marketplace advertising.',
        searchSocial:
          'Search engines and social networks — the paid channels most campaigns start with.',
      },
      platform: {
        amazonAds: 'Amazon Ads',
        amazonDsp: 'Amazon DSP',
        campaignManager360: 'Campaign Manager 360',
        dv360: 'Display & Video 360',
        googleAds: 'Google Ads',
        linkedinAds: 'LinkedIn Ads',
        metaAds: 'Meta Ads',
        microsoftAds: 'Microsoft Ads',
        theTradeDesk: 'The Trade Desk',
        tiktokAds: 'TikTok Ads',
        walmartConnect: 'Walmart Connect',
        youtubeAds: 'YouTube Ads',
      },
      platformDescription: {
        amazonAds:
          'Connect Amazon Ads to manage Sponsored Products & Brands retail-media campaigns.',
        amazonDsp: 'Connect Amazon DSP for programmatic advertising on Amazon.',
        campaignManager360:
          'Connect Campaign Manager 360 to import served delivery and Floodlight conversions.',
        dv360: 'Connect Display & Video 360 for programmatic campaign management.',
        googleAds: 'Connect your Google Ads account to import campaign data and automate delivery.',
        linkedinAds: 'Connect your LinkedIn Ads account to manage B2B campaign delivery.',
        metaAds: 'Connect your Meta Ads account to manage Facebook and Instagram campaigns.',
        microsoftAds: 'Connect Microsoft Ads to manage search and audience campaigns on Bing.',
        theTradeDesk: 'Connect The Trade Desk for DSP campaign automation.',
        tiktokAds:
          'Connect your TikTok Ads account to manage in-feed video and Spark Ads campaigns.',
        walmartConnect:
          'Connect Walmart Connect to manage Sponsored Products retail-media campaigns on Walmart.',
        youtubeAds: 'Connect YouTube Ads to manage video campaigns bought through Google Ads.',
      },
      status: {
        connected: 'Connected',
        disconnected: 'Disconnected',
        error: 'Error',
        expired: 'Expired',
        pending: 'Pending',
      },
      syncCadence: {
        daily: 'Daily',
        every12h: 'Every 12 hours',
        every6h: 'Every 6 hours',
        manual: 'Manual only',
      },
      syncCadenceDescription: {
        daily: 'Sufficient for most campaign management workflows.',
        every12h: 'Good balance of freshness and API quota usage.',
        every6h: 'Best for real-time pacing and in-flight optimization.',
        manual: 'Sync only when you click "Sync Now".',
      },
      syncStatus: {
        completed: 'Synced',
        failed: 'Sync failed',
        idle: 'Idle',
        running: 'Syncing...',
      },
    },
  },
  mediaConnectors: {
    addAccountDialog: {
      addPlatformAccount: 'Add {{platform}} Account',
      advertiserId: 'Advertiser ID',
      advertiserIdHelp:
        '{{platform}} connects to a partner, which buys nothing on its own — campaigns, creatives and reporting are all addressed per advertiser. Find the id in {{platform}}; it is checked before the account is saved.',
      cancel: 'Cancel',
      cm360AccountId: 'CM360 account ID',
      cm360AccountIdHelp:
        'Needed only when this Google login reaches more than one CM360 account. If you leave it blank and there are several, the connection stops and lists them.',
      connect: 'Connect',
      connecting: 'Connecting…',
      connectionMethod: 'Connection method',
      egUsMarketApac: 'e.g. US Market, APAC Region',
      managerAccountId: 'Manager account ID',
      managerAccountIdHelp:
        'The MCC this connection should use. Needed only when this Google login reaches more than one account. If you leave it blank and there are several, the connection stops and lists them. Dashes are fine.',
      pasteTheTokenGenerated: 'Paste the token generated in Meta Business Manager',
      removeTag: 'Remove {{tag}}',
      serviceAccountKeyFile: 'Service Account Key File',
      syncFrequency: 'Sync frequency',
      systemUserToken: 'System User Token',
      tags: 'Tags',
      title: 'Title',
      typeAndPressEnter: 'Type and press Enter to add tags',
      uploadJsonKeyFile: 'Upload JSON key file from Google Cloud Console',
    },
    capabilityBadge: {
      capabilityIsFailing: '{{capability}} is failing',
      lastChecked: 'Last checked {{timestamp}}',
      whyItFailed: '{{capability}}: why it failed',
    },
    editAccountDialog: {
      advertiser: 'Advertiser',
      advertiserEuDisclosure: 'Advertiser (EU disclosure)',
      advertiserHelp:
        'The account this connection buys in and reports on. Some logins reach an account that only holds others and runs nothing itself — a DV360 partner, a Google Ads manager account — and there every sync and publish fails until one is chosen.',
      advertisersCouldNotLoad:
        "Could not load the advertisers this account reaches. Test connection, in the account's menu, shows why.",
      egMonks: 'e.g. Monks',
      payerEuDisclosure: 'Payer (EU disclosure)',
      thePersonOrOrganisationTheAdsPromote:
        'The person or organisation the ads promote. Required before an ad set targeting the EU can publish.',
      whoPaysForTheAds: 'Who pays for the ads. Often the same as the advertiser.',
      cancel: 'Cancel',
      editAccount: 'Edit Account',
      egUsMarketApac: 'e.g. US Market, APAC Region',
      save: 'Save',
      searchAdvertisers: 'Search advertisers',
      selectAnAdvertiser: 'Select an advertiser',
      syncFrequency: 'Sync frequency',
      tags: 'Tags',
      title: 'Title',
      typeAndPressEnter: 'Type and press Enter to add tags',
      tryAgain: 'Try again',
    },
    mediaConnectorPane: {
      platformUnavailable: 'This platform is unavailable',
      selectAPlatform: 'Select a platform',
    },
    mediaConnectorDetail: {
      account: 'Account',
      accountActions: 'Account actions',
      accountId: 'Account ID',
      actions: 'Actions',
      addAccount: 'Add account',
      backToPaidMediaAd: 'Back to Paid Media & Ad Intelligence',
      capabilities: 'Capabilities',
      capabilitiesFailing_one:
        '{{capabilities}} is failing. Open the badge to see what the platform said.',
      capabilitiesFailing_other:
        '{{capabilities}} are failing. Open the badge to see what the platform said.',
      capabilityListJoiner: ' and ',
      connectYourFirstPlatformAccount:
        'Connect your first {{platform}} account to start managing campaigns.',
      couldNotTestAccount: 'Could not test this account. Try again in a moment.',
      delete: 'Delete',
      edit: 'Edit',
      enabled: 'Enabled',
      everythingIsWorking: 'Everything this account does is working.',
      lastSync: 'Last Sync',
      noAccountsConnected: 'No accounts connected',
      noAccountsMatchYourFilters: 'No accounts match your filters.',
      paidMediaAdIntelligence: 'Paid Media & Ad Intelligence',
      searchAccounts: 'Search accounts...',
      searchAccountsLabel: 'Search accounts',
      status: 'Status',
      syncFreq: 'Sync Freq.',
      syncNow: 'Sync Now',
      syncStartedDataWillRefresh: 'Sync started — data will refresh shortly',
      syncing: 'Syncing...',
      tags: 'Tags',
      testConnection: 'Test connection',
      testing: 'Testing…',
      thisAccount: 'this account',
      thisWillDisconnectTheAccount:
        'This will disconnect the account and remove it from this workspace. This action cannot be undone.',
      unableToConnectCheckYour: 'Unable to connect — check your network and try again',
      unableToStartSync: 'Unable to start sync — check your network and try again',
      unknownPlatformPleaseGoBack: 'Unknown platform. Please go back and select a valid platform.',
      untitledAccount: 'Untitled account',
    },
    mediaConnectorsHeader: {
      knowledge: 'Knowledge',
      paidMediaAdIntelligence: 'Paid media & ad intelligence',
      platforms: 'Platforms',
    },
    mediaConnectors: {
      accountCount_one: '{{count}} account',
      accountCount_other: '{{count}} accounts',
      accountsConnected_one: '{{count}} account connected',
      accountsConnected_other: '{{count}} accounts connected',
      addAccounts: 'Add accounts',
      all: 'All',
      backToKnowledge: 'Back to Knowledge',
      connectAdPlatformsAndData:
        'Connect ad platforms and data providers to enrich your knowledge base with campaign performance, audience insights, and competitive intelligence.',
      filterByCategory: 'Filter by category',
      filterPlatforms: 'Filter platforms',
      manageAccounts: 'Manage accounts',
      noPlatformsInThisCategory: 'No platforms in this category.',
      noPlatformsMatchYourSearch: 'No platforms match your search.',
      paidMediaAdIntelligence: 'Paid Media & Ad Intelligence',
      searchPlatforms: 'Search platforms',
      searchPlatformsPlaceholder: 'Search platforms...',
    },
    useOAuthPopup: {
      connectionFailed: 'Connection failed',
      failedToStartConnection: 'Failed to start connection. Please try again.',
      popupBlocked:
        'Your browser blocked the sign-in window. Allow pop-ups for this site and try again.',
      platformConnectedSuccessfully: 'Platform connected successfully',
    },
  },
  mediaGuideline: {
    types: {
      kind: {
        advisory: 'Advisory',
        attestation: 'Attestation',
        conditional: 'Conditional requirement',
        crossLevel: 'Cross-level consistency',
        namingPattern: 'Naming pattern',
        numericBound: 'Numeric bound',
        referenceList: 'Reference list',
        requiredValue: 'Required value',
        trackingUrl: 'Tracking and URLs',
      },
      level: {
        ad: 'Ad',
        adGroup: 'Ad set',
        campaign: 'Campaign',
        creative: 'Creative',
      },
      status: {
        active: 'Active',
        superseded: 'Superseded',
        unenforceable: 'Unenforceable',
      },
      tier: {
        advise: 'Advise',
        block: 'Block',
        warn: 'Warn',
      },
    },
  },
  mediaGuidelines: {
    guidelineEditorDialog: {
      addPart: 'Add part',
      aNameIsCheckedPartByPart:
        'A name is checked part by part, so a finding can say which one is wrong.',
      appliesAt: 'Applies at',
      atLeast: 'At least',
      atMost: 'At most',
      campaignCategory: 'Campaign category',
      cancel: 'Cancel',
      checksThat: 'Checks that',
      couldNotSaveTheGuideline: 'Could not save the guideline.',
      create: 'Create',
      draftSaved: 'Draft saved. Publish it to start enforcing.',
      editGuideline: 'Edit guideline',
      everyPlatform: 'Every platform',
      field: 'Field',
      guidelineCreatedAsADraft: 'Guideline created as a draft.',
      howToFixIt: 'How to fix it',
      nameIsFixedOncePublished:
        'The name is not versioned, so it cannot change while a draft is open. Publish this draft to rename it.',
      howToFixPlaceholder: 'Set the campaign budget type to Lifetime.',
      leaveBlankForEveryCategory: 'Leave blank for every category',
      leaveBlankForEveryPlatform: 'Leave blank for every platform',
      mustEqual: 'Must equal',
      name: 'Name',
      namePlaceholder: 'Lifetime budgets only',
      newGuideline: 'New guideline',
      partAllowedPlaceholder: 'AU, NZ — leave blank to allow anything',
      partAllowedValues: 'Part {{position}} allowed values',
      partName: 'Part {{position}} name',
      partNamePlaceholder: 'market',
      partsInOrder: 'Parts, in order',
      platform: 'Platform',
      remove: 'Remove',
      removePart: 'Remove part {{position}}',
      saveDraft: 'Save draft',
      separator: 'Separator',
      tier: 'Tier',
      unit: 'Unit',
      whyPlaceholder: 'Media plans are approved with a fixed budget per audience.',
      whyThisExists: 'Why this exists',
    },
    guidelinePlatformNav: {
      allPlatforms: 'All platforms',
      platforms: 'Platforms',
      platformsCouldNotBeLoaded: 'The platform list could not be loaded.',
    },
    guidelineRowActions: {
      delete: 'Delete',
      editDraft: 'Edit draft',
      newVersion: 'New version',
      publish: 'Publish',
      stopEnforcing: 'Stop enforcing',
    },
    mediaGuidelines: {
      backToKnowledge: 'Back to Knowledge',
      couldNotLoadGuidelines: 'Could not load the guidelines',
      couldNotUpdateTheGuideline: 'Could not update the guideline.',
      guidelineDeleted: 'Guideline deleted.',
      guidelinesAreStillThere:
        'Your guidelines are still there and still enforced. The list could not be read just now.',
      guidelinePublished: 'Guideline published. Pre-flight will enforce it from now on.',
      guidelineRetired: 'Guideline retired.',
      mediaGuidelines: 'Media Guidelines',
      newGuideline: 'New guideline',
      searchGuidelines: 'Search guidelines',
      searchGuidelinesPlaceholder: 'Search guidelines...',
      tryAgain: 'Try again',
      setTheNamingBudgetAndPlatform:
        "Set the naming, budget and platform-setting standards that Delivery's pre-flight QA checks every media plan against before it is published.",
      thereIsNoOpenDraftToPublish:
        'There is no open draft to publish. Edit the guideline to start one.',
      whyAreYouPublishingThisVersion: 'Why are you publishing this version?',
      whyIsThisNoLongerEnforced: 'Why is this no longer enforced?',
    },
    mediaGuidelinesTable: {
      actions: 'Actions',
      allCategories: 'All categories',
      category: 'Category',
      draft: 'Draft',
      level: 'Level',
      name: 'Name',
      never: 'Never',
      neverVerified: 'Never verified against the platform',
      noGuidelinesYet: 'No guidelines yet',
      status: 'Status',
      tier: 'Tier',
      verified: 'Verified',
    },
    platformRulesPanel: {
      allPlatformsChecksRunHereToo: 'The All platforms checks run here too.',
      alwaysOn: 'Always on, and checked before your own guidelines.',
      couldNotLoadPlatformRules:
        'The platform rules could not be loaded, so this page cannot say what pre-flight enforces before your own guidelines. They are still enforced.',
      checkCount_one: '{{count}} check, {{blocking}} of them blocking.',
      checkCount_other: '{{count}} checks, {{blocking}} of them blocking.',
      monksFlowStandard: 'Monks.Flow standard',
      nothingSpecificToThisPlatform: 'Nothing specific to this platform.',
    },
  },
  taxonomy: {
    common: {
      versionLabel: 'v{{number}}',
      versionStatusDraft: 'draft',
      versionStatusPublished: 'published',
      versionStatusArchived: 'archived',
      levelAll: 'All levels',
      levelCampaign: 'Campaign',
      levelAdSet: 'Ad Set',
      levelAd: 'Ad',
    },
    abbreviationSuggestionsModal: {
      applyAll: 'Apply all ({{count}})',
      applyDateFormats_one: 'Apply {{count}} date format',
      applyDateFormats_other: 'Apply {{count}} date formats',
      planReduction_one:
        "We'll plan a reduction of at least <amount>{{count}}</amount> character — taking the cheap wins first (a 2-digit year saves 2 per date field), then spreading the rest across your longest codes. Nothing changes until you apply it.",
      planReduction_other:
        "We'll plan a reduction of at least <amount>{{count}}</amount> characters — taking the cheap wins first (a 2-digit year saves 2 per date field), then spreading the rest across your longest codes. Nothing changes until you apply it.",
      unlinkFields_one: 'Unlink {{count}} field',
      unlinkFields_other: 'Unlink {{count}} fields',
      allowUnlinkingFieldsFollowShared: 'Allow unlinking fields that follow a shared List',
      alsoShortenCodesOwnedShared: 'Also shorten codes owned by shared Lists',
      applied: 'Applied',
      apply: 'Apply',
      cancel: 'Cancel',
      close: 'Close',
      couldnAposTGenerateSuggestions: 'Couldn’t generate suggestions.',
      dateFormats: 'Date formats',
      done: 'Done',
      dropsDateComponentNotJust: 'Drops a date component, not just a shorter year',
      fieldsUnlink: 'Fields to unlink',
      fits: 'fits',
      lessPrecise: 'less precise',
      mostFieldsHereTakeTheir:
        'Most fields here take their options from a shared List, and those codes can’t be shortened without changing the list for every schema using it. Instead, this schema takes its own copy of the values — no other schema is touched, but the field stops receiving future list updates. Leave it off to keep every binding intact; the plan may not reach the budget alone.',
      noFurtherShorteningAvailableCodes:
        'No further shortening available — codes are already as short as they can be while staying unique.',
      rePlanUnlinkingThoseFields: 'Re-plan, unlinking those fields',
      shortenAi: 'Shorten with AI',
      shortenToChars: 'Shorten to {{limit}} chars',
      goalWithPlatform:
        'Shorter codes that keep each field’s values unique and fit the {{platform}} {{limit}}-char limit.',
      goal: 'Shorter codes that keep each field’s values unique to fit {{limit}} chars.',
      suggestedAbbreviations: 'Suggested abbreviations',
      theseTakeTheirOwnCopy:
        'These take their own copy of the list values so the shorter codes stay in this schema. The lists themselves are untouched.',
      tryAgain: 'Try again',
      worstCaseWithPlatform:
        'This name is <num>{{current}}</num> characters at worst case. <platform/> is the tightest limit you’ve selected, so shortening to <num>{{target}}</num> makes it fit <em>every</em> platform at once.',
      worstCaseWithBudget:
        'This name is <num>{{current}}</num> characters at worst case. The budget is <num>{{target}}</num> characters.',
      overBy: '{{amount}} over',
      planningReduction: 'Planning a {{amount}}-character reduction…',
      planFits:
        'Applying the whole plan takes the name from <num>{{current}}</num> to <num>{{projected}}</num> characters — within the {{target}} budget.',
      planFallsShort:
        'This plan gets the name to <num>{{projected}}</num> characters, still <num>{{shortfall}}</num> over the {{target}} budget — every remaining code is already at its shortest unique length.',
      sharedListPotential:
        'Fields that follow a shared List could give up another <num>{{amount}}</num> characters, which would close the gap. Their codes belong to the list, so this schema would take its own copy of the values instead of changing the list.',
      wasFollowingList: 'was following {{list}}',
      wasFollowingSharedList_one: 'was following {{list}} · used by {{count}} schema',
      wasFollowingSharedList_other: 'was following {{list}} · used by {{count}} schemas',
      valueCount_one: '{{count}} value',
      valueCount_other: '{{count}} values',
    },
    addFieldModal: {
      writesDatesAs: 'Writes dates as {{example}}',
      leaveBlankForMask: 'Leave blank for {{mask}}',
      listWithOptions_one: '{{name}} list · {{count}} option',
      listWithOptions_other: '{{name}} list · {{count}} options',
      addField: 'Add field',
      addFieldCategoryFieldsTab:
        'Add a field to this category from the Fields tab and it will show up here. You can also use Custom to define one directly on this schema.',
      addSubfield: 'Add subfield',
      added: 'Added',
      back: '← Back',
      cancel: 'Cancel',
      computedColumnAssembledOtherFields:
        'A computed column assembled from other fields, dates and a unique sequence — configured from its column menu. Great for logical variables concatenated into the name.',
      contentField: 'Content field',
      customField: 'Custom field',
      dataType: 'Data type',
      dateFormat: 'Date format',
      defineYourOwnFieldName: 'Define your own field — name, type, values and codes.',
      done: 'Done',
      eGObjective: 'e.g. Objective',
      field: 'Field',
      fieldName: 'Field name',
      generatedNamesMustIncludeValue: 'Generated names must include a value for this field.',
      governance: 'Governance',
      hierarchyLevel: 'Hierarchy level',
      linkedSchema: 'Linked schema',
      mediaField: 'Media field',
      pullsUniqueIdentifierAnotherSchema:
        'Pulls a unique identifier from another schema (its tracking code or a field) to act as a join key for external metadata platforms — configured from its column menu.',
      required: 'Required',
      requiredField: 'Required field',
      section: 'Section',
      type: 'Type',
      variable: 'Variable',
      whereFieldSitsCampaignAd: 'Where this field sits (Campaign / Ad Set / Ad).',
      whichHalfSchemaColumnBelongs: 'Which half of the schema this column belongs to.',
      dateWithFormat: 'Date · {{format}}',
      noFieldsInCategoryYet: 'No fields in “{{category}}” yet',
    },
    campaign: {
      label: 'Campaign',
      ungrouped: 'Ungrouped',
      taxonomyCount_one: '{{count}} taxonomy',
      taxonomyCount_other: '{{count}} taxonomies',
      none: 'None',
      existing: 'Existing',
      new: 'New',
      selectPlaceholder: 'Select campaign',
      namePlaceholder: 'Enter campaign name',
      nameLabel: 'Campaign name',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'What this campaign groups (optional)',
      editTitle: 'Edit campaign',
      save: 'Save',
      deleteWarning_one: 'Its {{count}} taxonomy will be kept and moved to Ungrouped.',
      deleteWarning_other: 'Its {{count}} taxonomies will be kept and moved to Ungrouped.',
      deleteWarning_zero: 'It has no taxonomies.',
      updated: 'Campaign updated',
      failedUpdate: 'Could not update the campaign',
      deleted: 'Campaign deleted',
      failedDelete: 'Could not delete the campaign',
      moved: 'Taxonomy moved',
      createdUnreadable:
        'The campaign was created, but its details could not be read. Refresh to see it.',
      failedMove: 'Could not move the taxonomy',
      expandGroup: 'Expand {{name}}',
      collapseGroup: 'Collapse {{name}}',
      moveToCampaign: 'Move to campaign',
    },
    multiSelect: {
      searchPlaceholder: 'Search options',
      noMatches: 'No matching options',
    },
    addRuleModal: {
      elseIfBranch: 'Else if (branch {{branch}})',
      is: 'is',
      isNot: 'is not',
      limitOptionsAction: 'Limit options',
      requireField: 'Require field',
      setDefault: 'Set default',
      showField: 'Show field',
      addBranch: 'Add branch',
      addCondition: 'Add condition',
      addGroup: 'Add group',
      addRule: 'Add rule',
      cancel: 'Cancel',
      defaultValue: 'Default value',
      editRule: 'Edit rule',
      if: 'If',
      limitOptions: 'Limit options to',
      match: 'Match',
      noValuesDefined: 'No values defined',
      removeBranch: 'Remove branch',
      removeCondition: 'Remove condition',
      removeGroup: 'Remove group',
      saveRule: 'Save rule',
      selectField: 'Select field…',
      selectFieldFirst: 'Select a field first',
      selectTargetFieldFirst: 'Select a target field first',
      selectValue: 'Select value…',
      selectValues: 'Select values…',
      targetField: 'Target field',
      typeDefaultValue: 'Type the default value',
      targetFieldHasNoValues: 'Target field has no values',
      targetFieldWillOnlyShown: 'The target field will only be shown when the conditions match.',
      targetFieldWillRequiredWhen: 'The target field will be required when the conditions match.',
      then: 'Then',
    },
    addStandardCategoriesModal: {
      addCategory: 'Add {{name}}',
      addStandardCategories: 'Add standard categories',
      alreadyAdded: 'Already added',
      cancel: 'Cancel',
      groupingsMonksflowOrganisesStandardField:
        'The groupings MonksFlow organises its standard field library into. Each arrives with an icon and a position in the Add field picker, and you can rename or re-order any of them afterwards.',
      addCategories_one: 'Add {{count}} category',
      addCategories_other: 'Add {{count}} categories',
      selectAllCount: 'Select all ({{count}})',
      selectAllCategories: 'Select all categories',
      selectLeastOne: 'Select at least one',
      standardFieldCount_one: '{{count}} standard field',
      standardFieldCount_other: '{{count}} standard fields',
      yourRegistryAlreadyHasEvery: 'Your registry already has every standard category.',
    },
    addStandardFieldsModal: {
      /**
       * Named because the count is the actionable part. "This will also create
       * lists" tells someone nothing; a number tells them whether Select all is
       * the convenience they wanted or a bigger commitment than they expected.
       */
      alsoCreatesLists_one: 'Also creates {{count}} shared list.',
      alsoCreatesLists_other: 'Also creates {{count}} shared lists.',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      addField: 'Add {{name}}',
      addStandardFields: 'Add standard fields',
      alreadyAdded: 'Already added',
      cancel: 'Cancel',
      fieldDefinitionsMonksflowMaintainsEach:
        'Field definitions MonksFlow maintains. Each arrives bound to its governed list where one exists, and you can edit any of them afterwards.',
      addFields_one: 'Add {{count}} field',
      addFields_other: 'Add {{count}} fields',
      selectAllCount: 'Select all ({{count}})',
      selectAllFields: 'Select all fields',
      selectLeastOne: 'Select at least one',
    },
    addStandardListsModal: {
      addList: 'Add {{name}}',
      addLists_one: 'Add {{count}} list · {{options}} options',
      addLists_other: 'Add {{count}} lists · {{options}} options',
      addStandardLists: 'Add standard lists',
      adding: 'Adding…',
      alreadyAdded: 'Already added',
      cancel: 'Cancel',
      selectAllLists: 'Select all lists',
      selectLeastOne: 'Select at least one',
      vocabulariesMonksflowMaintainsAddOnes:
        'Vocabularies MonksFlow maintains. Add the ones you want — you can edit them freely afterwards.',
      selectAllCount: 'Select all ({{count}})',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
    },
    bulkPasteModal: {
      pasteMode: 'Paste mode',
      addRowCount_one: 'Add {{count}} row',
      addRowCount_other: 'Add {{count}} rows',
      addToExisting: 'Add to existing ({{count}})',
      extraColumnsIgnored_one:
        'Your data has {{widest}} columns. Paste options fills only Value and Code, so the extra column will be ignored.',
      extraColumnsIgnored_other:
        'Your data has {{widest}} columns. Paste options fills only Value and Code, so the extra {{count}} columns will be ignored.',
      previewRows_one: 'Preview — {{count}} row',
      previewRows_other: 'Preview — {{count}} rows',
      replaceRows_one: 'Replace {{count}} row',
      replaceRows_other: 'Replace {{count}} rows',
      addRows: 'Add rows',
      cancel: 'Cancel',
      copyCellsStraightExcelGoogle:
        'Copy cells straight from Excel, Google Sheets or a CSV and paste below. Columns are matched left-to-right against',
      firstRowHeader: 'First row is a header',
      northAmericaTnaNemeaTem: 'North America\\tNA\\nEMEA\\tEM\\nAPAC\\tAP',
      pasteOptionsSpreadsheet: 'Paste options from a spreadsheet',
      pasteSpreadsheetData: 'Paste spreadsheet data',
      replaceAll: 'Replace all',
      andMore_one: '…and {{count}} more.',
      andMore_other: '…and {{count}} more.',
    },
    categoryActionMenu: {
      actionsFor: 'Actions for {{name}}',
      deleteCategory: 'Delete category',
      edit: 'Edit',
    },
    categoryModal: {
      cancel: 'Cancel',
      createCategory: 'Create category',
      chooseCategoryIcon: 'Choose category icon',
      eGGeography: 'e.g. Geography',
      editCategory: 'Edit category',
      fieldsWillMove_one: '{{count}} field currently in “{{from}}” will move to “{{to}}”.',
      fieldsWillMove_other: '{{count}} fields currently in “{{from}}” will move to “{{to}}”.',
      iconAppearsBesideCategoryAdd:
        'The icon appears beside this category in the Add field picker.',
      nameIcon: 'Name and icon',
      newCategory: 'New category',
      saveCategory: 'Save category',
    },
    constants: {
      allSchemas: 'All schemas',
      archived: 'Archived',
      draft: 'Draft',
      published: 'Published',
    },
    createListModal: {
      pasteCopiedList: 'Paste a copied list (optional)',
      pasteCopiedListHint:
        'Paste a list copied with Copy list, or any table whose first row names the columns. Its columns and rows are added to the new list.',
      pastedListSummary_one: '{{columns}} columns ({{names}}), {{count}} row',
      pastedListSummary_other: '{{columns}} columns ({{names}}), {{count}} rows',
      pasteErrorEmpty: 'There is nothing to read in the pasted text.',
      pasteErrorBlankColumnName: 'Column {{column}} in the first row has no name.',
      pasteErrorDuplicateColumnName:
        'Two columns are called “{{name}}”. Column names must be different.',
      pasteErrorColumnNameTooLong: 'The column name “{{name}}” is longer than 100 characters.',
      pasteErrorTooManyColumns:
        'The pasted list has {{count}} columns. A list can have at most 50.',
      pasteErrorTooManyRows: 'The pasted list has {{count}} rows. A list can have at most 20,000.',
      pasteErrorRowTooWide: 'Row {{row}} has more values than there are column names.',
      pasteErrorCellTooLong: 'Row {{row}} has a value longer than 1,000 characters.',
      cancel: 'Cancel',
      createList: 'Create list',
      creating: 'Creating…',
      descriptionOptional: 'Description (optional)',
      eGRegions: 'e.g. Regions',
      listName: 'List name',
      newList: 'New list',
      organization: 'Organization',
      organizationListsReusableEveryWorkspace:
        'Organization lists are reusable by every workspace — usually what you want for a shared vocabulary.',
      scope: 'Scope',
      whatVocabularyCovers: 'What this vocabulary covers…',
      workspace: 'Workspace',
    },
    createTaxonomyModal: {
      cancel: 'Cancel',
      create: 'Create',
      description: 'Description',
      enterSchemaName: 'Enter schema name',
      startFrom: 'Start from',
      blank: 'Blank',
      aFile: 'A file',
      readFile: 'Read file',
      market: 'Market',
      newSchema: 'New schema',
      org: 'Org',
      platform: 'Platform',
      schemaName: 'Schema name',
      scope: 'Scope',
      selectMarkets: 'Select markets…',
      selectPlatforms: 'Select platforms…',
      shareAnyAdditionalContextSchema: 'Share any additional context for this schema.',
      workspace: 'Workspace',
    },
    deleteListDialog: {
      checkingUsage: 'Checking which schemas use this list…',
      couldNotCheckUsage:
        "Couldn't check which schemas use this list, so it can't be deleted right now. Close and try again.",
      cancel: 'Cancel',
      deleteList: 'Delete list',
      deleteNamed: 'Delete “{{name}}”?',
      noSchemaUsesList_one:
        'No schema uses this list, so nothing breaks. Its {{count}} option and every version go with it.',
      noSchemaUsesList_other:
        'No schema uses this list, so nothing breaks. Its {{count}} options and every version go with it.',
      schemasStillBind_one:
        "{{count}} schema still binds a field to this list, so it can't be deleted. Unlink it there, and publish the schema again if its published version uses this list.",
      schemasStillBind_other:
        "{{count}} schemas still bind a field to this list, so it can't be deleted. Unlink it there, and publish again any schema whose published version uses this list.",
    },
    diffVersions: {
      withNotes: '{{text}} ({{notes}})',
      linkIncludedInName: '{{what}}, included in the name',
      differentSchema: 'different schema',
      differentField: 'different field',
      differentList: 'different list',
      differentListVersion: 'different version',
      valueColumnChanged: 'value column changed',
      codeColumnChanged: 'code column changed',
      pinSourceChanged: 'pinned by a different action',
      outputFormula: '{{name}}: {{formula}}',
      outputWithFlags: '{{text}} ({{flags}})',
      outputPrimary: 'primary',
      outputUnique: 'unique',
      outputLocked: 'locked',
      content: 'Content',
      media: 'Media',
      channelLimits: 'Channel limits',
      columnOrder: 'Column order',
      defaultValue: 'Default value',
      description: 'Description',
      edited: '(edited)',
      field: 'a field',
      fieldDelimiter: 'Field delimiter',
      format: 'Format',
      level: 'Level',
      libraryKey: 'Library key',
      link: 'Linked schema',
      linkedList: 'Linked list',
      linkedListFollowing: 'Linked list (follows latest)',
      linkedListPinned: 'Linked list (pinned)',
      linkedSchema: 'Linked',
      markets: 'Markets',
      multiselect: 'Multiselect',
      name: 'Name',
      no: 'No',
      outputs: 'Outputs',
      parent: 'Parent field',
      pattern: 'Pattern',
      patternParts_one: '{{count}} part',
      patternParts_other: '{{count}} parts',
      platforms: 'Platforms',
      required: 'Required',
      ruleOrder: 'Rule order',
      section: 'Section',
      subfieldDelimiter: 'Subfield delimiter',
      trackingCodePattern: 'Tracking code pattern',
      transform: 'Transform',
      type: 'Type',
      unique: 'Unique',
      validationPattern: 'Validation pattern',
      visible: 'Visible',
      yes: 'Yes',
    },
    editFieldModal: {
      appliedFieldOutputGeneratedName: "Applied to this field's output in the generated name.",
      cancel: 'Cancel',
      clear: 'Clear',
      contentField: 'Content field',
      dateFormat: 'Date format',
      defaultValueOptional: 'Default value (optional)',
      descriptionOptional: 'Description (optional)',
      documentsFieldDataDictionary:
        'Documents the field for the data dictionary and for teams without platform access.',
      eachRecordMustHaveDifferentValue: 'Each record must have a different value for this field.',
      editField: 'Edit field',
      eGObjective: 'e.g. Objective',
      fieldName: 'Field name',
      followsParentField: 'the parent field',
      formatsOnlyApplyDateFields:
        "Formats only apply to Date fields. It's ignored for {{type}} and will be removed when you save.",
      generatedNamesMustIncludeValue: 'Generated names must include a value for this field.',
      governance: 'Governance',
      hierarchyLevel: 'Hierarchy level',
      leaveBlankFor: 'Leave blank for {{mask}}',
      leftoverDateFormat: 'Leftover date format “{{format}}”',
      mediaField: 'Media field',
      notValidRegularExpression: 'Not a valid regular expression.',
      preselectedWhenRecordCreated: 'Preselected when a record is created',
      regexEG: 'Regex, e.g. ^[A-Z]{2,4}$',
      required: 'Required',
      requiredField: 'Required field',
      save: 'Save',
      section: 'Section',
      shownDuringSubmissionHideAutoGenerated:
        'Shown during submission. Hide fields that are auto-generated.',
      subfieldStaysSameSection:
        'Follows {{parent}} — a subfield stays in the same section. Move the parent to move both.',
      textTransformation: 'Text transformation',
      type: 'Type',
      unique: 'Unique',
      uniqueField: 'Unique field',
      valueMustMatchFull:
        'The value must match this in full. Enforced when a tracking code is generated; empty values are exempt.',
      validationPatternOptional: 'Validation pattern (optional)',
      visible: 'Visible',
      visibleField: 'Visible field',
      whatFieldIsFor: 'What this field is for…',
      whereFieldSitsHierarchy:
        'Where this field sits in the campaign hierarchy — used by the name generator.',
      writesDatesAs: 'Writes dates as {{example}}',
    },
    fieldActionMenu: {
      removeFromLibrary: 'Remove from library',
      actionsFor: 'Actions for {{name}}',
      edit: 'Edit',
      history: 'History',
    },
    fieldHistoryDrawer: {
      restored: 'Restored',
      created: 'Created',
      deleted: 'Deleted',
      edited: 'Edited',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      closeHistory: 'Close history',
      couldnTLoadHistory: 'Couldn’t load the history.',
      linkedList: 'linked list',
      noChangesRecordedYet: 'No changes recorded yet.',
      teamMember: 'Team member',
      you: 'You',
      namedHistory: '{{name}} history',
    },
    fieldPattern: {
      doesNotMatchPattern:
        'Doesn’t match this field’s validation pattern {{pattern}} — generating a name with this value will be rejected.',
      tooLong: 'Too long — values are capped at {{cap}} characters.',
    },
    fieldTemplateModal: {
      writesDatesAs: 'Writes dates as {{example}}',
      leaveBlankForMask: 'Leave blank for {{mask}}',
      orphanCategory: '“{{name}}” is no longer a category — pick one to re-file this field.',
      addLibrary: 'Add to library',
      cancel: 'Cancel',
      category: 'Category',
      chooseCategory: 'Choose a category',
      contentField: 'Content field',
      createCategoryFirstCategoriesTab: 'Create a category first, on the Categories tab.',
      dataType: 'Data type',
      dateFormat: 'Date format',
      defaultSchemasUsing: 'Default for schemas using it.',
      descriptionOptional: 'Description (optional)',
      eGObjective: 'e.g. Objective',
      eachRecordMustHaveDifferent: 'Each record must have a different value.',
      editField: 'Edit field',
      editingDefinitionDoesNotChange:
        'Editing this definition does not change schemas that already use it — they hold their own copy.',
      fieldName: 'Field name',
      governance: 'Governance',
      hierarchyLevel: 'Hierarchy level',
      managedCategoriesTab: 'Managed on the Categories tab.',
      mediaField: 'Media field',
      newReusableField: 'New reusable field',
      notValidRegularExpression: 'Not a valid regular expression.',
      placement: 'Placement',
      regexEGZ2: 'Regex, e.g. ^[A-Z]{2,4}$',
      required: 'Required',
      saveField: 'Save field',
      saving: 'Saving…',
      section: 'Section',
      textTransformation: 'Text transformation',
      type: 'Type',
      unique: 'Unique',
      validationPatternOptional: 'Validation pattern (optional)',
      whatField: 'What this field is for…',
      whichHalfSchemaLands: 'Which half of the schema it lands in.',
      missingCategory: '{{name}} (missing)',
    },
    fieldTypes: {
      date: 'Date',
      dropdown: 'Dropdown',
      freeText: 'Free text',
      linkedSchema: 'Linked schema',
      number: 'Number',
      variable: 'Variable',
    },
    fieldsEditor: {
      clearSkipped:
        "Generated and list-linked columns get their values from elsewhere, so they can't be cleared here.",
      pasteSkipped_one:
        '{{count}} pasted value landed on a generated or list-linked column and was skipped.',
      pasteSkipped_other:
        '{{count}} pasted values landed on generated or list-linked columns and were skipped.',
      hierarchyLevel: 'Campaign-hierarchy level: {{level}}',
      fieldActions: '{{name}} field actions',
      listFollowingVersion: '{{name}} · following v{{version}}',
      listPinnedToVersion: '{{name}} · pinned to v{{version}}',
      resetToDefault: 'Reset “{{name}}” to default?',
      subfieldOfType: 'Subfield · {{type}}',
      linked: 'linked',
      resetReplacesValues_one:
        'This replaces the current values and codes for <strong>{{name}}</strong> with the {{count}} standard value it shipped with. Any edits you made to this column will be lost. This can’t be undone.',
      resetReplacesValues_other:
        'This replaces the current values and codes for <strong>{{name}}</strong> with the {{count}} standard values it shipped with. Any edits you made to this column will be lost. This can’t be undone.',
      contentFields: 'Content fields',
      mediaFields: 'Media fields',
      addField: 'Add field',
      addFieldRight: 'Add field to the right',
      addRow: 'Add row',
      addSubfield: 'Add subfield',
      boundSharedList: 'Bound to a shared list',
      cellOwnedByList: 'This column follows a shared list. Edit these options in the list itself.',
      cancel: 'Cancel',
      clickRename: 'Click to rename',
      code: 'Code',
      configure: 'Configure',
      delete: 'Delete',
      detachParent: 'Detach from parent',
      dragReorderColumn: 'Drag to reorder column',
      duplicate: 'Duplicate',
      edit: 'Edit',
      generateSample: 'Generate sample',
      sampleToast: 'Sample: {{code}}',
      notConfigured: '— not configured',
      openCalendar: 'Open calendar',
      pickDate: 'Pick date',
      resetDefault: 'Reset to default',
      resizeColumn: 'Resize column',
      subfield: 'Subfield',
      unlinkList: 'Unlink from list',
      editListBinding: 'Edit list binding…',
      withCodesSameAsDisplay: '{{label}} · codes: same as display value',
      useSharedList: 'Use a shared list…',
      value: 'Value',
      variableNotConfigured: 'Variable · not configured',
      noMediaFieldsYet: 'No media fields yet.',
      noContentFieldsYet: 'No content fields yet.',
      duplicateName: '{{name}} copy',
    },
    historyDrawer: {
      archived: 'Archived',
      created: 'Created',
      deleted: 'Deleted',
      merged: 'Merged',
      newVersion: 'New version',
      published: 'Published',
      restored: 'Restored',
      unpublished: 'Unpublished',
      updated: 'Updated',
      closeHistory: 'Close history',
      couldnTLoadHistory: 'Couldn’t load the history.',
      history: 'History',
      noChangesRecordedYet: 'No changes recorded yet.',
      seeChanges: 'See changes',
      unknownUser: 'Unknown user',
      you: 'You',
    },
    hubCard: {
      countLabel_one: 'schema',
      countLabel_other: 'schemas',
      description:
        'Versioned naming schemas that keep campaign, creative and media names consistent across every market and platform.',
      title: 'Taxonomy Administration',
    },
    iconPicker: {
      chooseIcon: 'Choose icon',
      noIconMatches: 'No icon matches “{{query}}”.',
      searchIcons: 'Search icons…',
      searchIconsLabel: 'Search category icons',
      useDefault: 'Use the default',
    },
    listBinding: {
      pinnedToListVersion: 'Pinned to v{{version}} of the {{name}} list',
      optionsFrom: 'Options from',
      fieldsOwnValues: 'This field’s own values',
      listCannotBeBoundYet:
        'Couldn’t read “{{name}}”. Its published version needs a value column and a code column before a field can follow it.',
      followsListWithOptions_one: 'Follows the {{name}} list · {{count}} option',
      followsListWithOptions_other: 'Follows the {{name}} list · {{count}} options',
      listNeedsTwoColumns: '{{name}} · needs a display and a code column',
      listWorkspaceOnly:
        '{{name}} · only in its own workspace, and this schema is organization-wide',
      noSharedListsAvailableYet: 'No shared lists available yet — add some on the Lists tab.',
      bindSharedListKeepField: 'Bind to a shared list, or keep this field’s own values.',
      codesFrom: 'Codes from',
      sameAsDisplayValue: 'Same as display value',
      codesFromSameHint: 'Each option’s display value is also its code in the generated name.',
      codesFromColumnHint: 'The generated name uses this column’s cell as the code.',
      nothingPublishedToPin: 'This list has no published version yet, so it can only be followed.',
    },
    fillEmptyCellsModal: {
      copyFrom: 'Copy from',
      title: 'Fill empty cells',
      explainer:
        'Copies each row’s “{{source}}” value into the empty cells of the columns you tick. Cells that already have a value are not changed, and later edits are not copied.',
      fill: 'Fill empty cells',
      cancel: 'Cancel',
    },
    linkListModal: {
      editListBindingFor: 'Edit list binding for “{{name}}”',
      save: 'Save',
      useSharedListFor: 'Use a shared list for “{{name}}”',
      optionsWillReplace_one:
        '{{count}} option will replace the {{typed}} typed into this column. Your typed options are kept and restored if you unlink.',
      optionsWillReplace_other:
        '{{count}} options will replace the {{typed}} typed into this column. Your typed options are kept and restored if you unlink.',
      cancel: 'Cancel',
      columnAposSOptionsWill:
        'This column’s options will come from a shared list instead of being typed here — so updating the list updates every schema that uses it.',
      displayValueColumn: 'Display value column',
      followList: 'Follow the list',
      followListHead: 'Follow this list’s published version',
      list: 'List',
      noListsYetCreateOne: 'No lists yet — create one in the Lists tab.',
      followOrPinExplainer:
        'On: this schema reads the latest published version automatically. Off: pinned to v{{version}}, so the vocabulary is frozen.',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      outputCodeColumn: 'Output code column',
      sameDisplayValue: 'Same as display value',
      selectColumn: 'Select column…',
      selectList: 'Select a list…',
      useList: 'Use this list',
    },
    publishBlockedLists: {
      cannotPublishYet_one: 'One list this schema uses has never been published.',
      cannotPublishYet_other: '{{count}} lists this schema uses have never been published.',
      listHasNoPublishedVersion: '{{name}} has no published version yet.',
      publishNow: 'Publish now',
      publishNamedNow: 'Publish the list “{{name}}” now',
      publishedToUnblock: 'Published to unblock publishing the schema “{{name}}”.',
      publishingAgainstPublished_one: 'One list has newer work that this schema will not read.',
      publishingAgainstPublished_other:
        '{{count}} lists have newer work that this schema will not read.',
      readingVersionNotDraft: '{{name}}: reading v{{version}}, not the unpublished v{{draft}}.',
    },
    linkedSchema: {
      field: 'field',
      fieldValue: 'field (value)',
      linkedSchemaNotConfigured: 'Linked schema · not configured',
      schema: 'schema',
      trackingCode: 'tracking code',
    },
    linkedSchemaComposer: {
      cancel: 'Cancel',
      code: 'Code',
      configureLinkedSchema: 'Configure linked schema',
      emit: 'Emit',
      field: 'Field',
      identifier: 'Identifier',
      includeGeneratedName: 'Include in generated name',
      joinKey: 'Join key',
      noOtherSchemasLink: 'No other schemas to link to.',
      noPullableFields: 'No pullable fields.',
      offDefaultStoredSeparateReference:
        'Off (default): stored as a separate reference column the API serves as a join key. On: also concatenated into the name string (counts against channel limits).',
      pickSchemaFirst: 'Pick a schema first',
      pickSchemaFirst2: 'Pick a schema first.',
      pullSchema: 'Pull from schema',
      saveLink: 'Save link',
      selectField: 'Select field',
      selectSchema: 'Select a schema',
      specificField: 'A specific field',
      targetSchemaSStandaloneJoin:
        "The target schema's standalone join key — configure it under that schema's Rules.",
      uniqueTrackingCodeRecommended: 'Unique tracking code (recommended)',
      value: 'Value',
    },
    listActionMenu: {
      actionsFor: 'Actions for {{name}}',
      deleteList: 'Delete list',
      duplicate: 'Duplicate',
    },
    listHistoryDrawer: {
      renumberedFrom: 'was v{{version}}',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      columnCount_one: '{{count}} column',
      columnCount_other: '{{count}} columns',
      restoredFromVersion: 'from v{{version}}',
      archived: 'Archived',
      deleted: 'Deleted',
      listCreated: 'List created',
      newVersion: 'New version',
      published: 'Published',
      restored: 'Restored',
      unpublished: 'Unpublished',
      updated: 'Updated',
      closeHistory: 'Close history',
      couldnTLoadHistory: 'Couldn’t load the history.',
      history: 'History',
      monksflowStandard: 'MonksFlow standard',
      noChangesRecordedYet: 'No changes recorded yet.',
      teamMember: 'Team member',
      viewVersion: 'View this version',
      you: 'You',
    },
    listImpactSummary: {
      checkingWhichSchemasUseList: 'Checking which schemas use this list…',
      noSchemaBindsFieldList:
        'No schema binds a field to this list yet — publishing affects nothing.',
      pinnedToOlderVersion_one: '{{count}} pinned to an older version — unaffected',
      pinnedToOlderVersion_other: '{{count}} pinned to an older version — unaffected',
      schemasFollowList_one: '{{count}} schema follows this list and will pick up these changes',
      schemasFollowList_other: '{{count}} schemas follow this list and will pick up these changes',
    },
    rules: {
      branchSummary: 'IF {{when}} THEN {{then}}',
      is: 'is',
      isNot: 'is not',
      noConditions: '(no conditions)',
      condition: '{{field}} {{operator}} “{{value}}”',
      orJoiner: ' OR ',
      andJoiner: ' AND ',
      limitOptions: 'Limit {{target}} options to {{values}}',
      showField: 'Show {{target}}',
      setDefault: 'Set {{target}} default to {{value}}',
      requireField: 'Require {{target}}',
    },
    rulesEditor: {
      addRule: 'Add rule',
      conditionalLogicLimitOptionsShow:
        'Conditional logic — limit options, show, default or require a field based on other values.',
      deleteRule: 'Delete rule',
      editRule: 'Edit rule',
      elseIf: 'Else if',
      field: 'field',
      if: 'If',
      noRulesYetAddRule: 'No rules yet. Add a rule to create conditional field logic.',
      then: 'Then',
    },
    schemaPreview: {
      overLimit: '{{platform}}: {{overBy}} over the {{limit}}-char limit',
      withinLimit: '{{platform}}: within the {{limit}}-char limit',
      storedReferenceNotInName: '{{name}} is a stored reference, not part of the generated name',
      addFieldsBelowPreviewConcatenated: 'Add fields below to preview the concatenated name.',
      howGeneratedNameLooksYou: 'How the generated name looks as you build the schema',
      required: 'required',
      schemaPreview: 'Schema Preview',
      shortenAi: 'Shorten with AI',
      maxLengthChars: 'Max length <num>{{length}}</num> chars',
    },
    schemaProperties: {
      org: 'Org',
      workspace: 'Workspace',
      addDescription: 'Add a description…',
      comingSoon: 'Coming soon',
      description: 'Description',
      fields: 'Fields',
      import: 'Import',
      lastModified: 'Last modified',
      markets: 'Markets',
      platforms: 'Platforms',
      schemaName: 'Schema name',
      schemaProperties: 'Schema Properties',
      scope: 'Scope',
      select: 'Select…',
      source: 'Source',
      upload: 'Upload',
      fieldCounts: '{{media}} media · {{content}} content',
    },
    schemaSettings: {
      /**
       * Deliberately names both numbers. "Almost full" tells a user nothing they
       * can act on; a count against a ceiling tells them how much room is left
       * and that the ceiling is a number somebody chose.
       */
      trackingCodesUsed: '{{used}} of {{cap}} tracking codes used.',
      trackingCodesNearlyGone:
        'A tracking code is permanent and none are ever released, so raise this schema’s cap before it runs out.',
      custom: 'custom',
      default: 'default',
      trackingCode: 'Tracking code',
      betweenFieldSubfields: 'Between a field and its subfields.',
      betweenTopLevelFields: 'Between top-level fields.',
      channelCharacterLimits: 'Channel character limits',
      configure: 'Configure',
      configureTrackingCode: 'Configure tracking code',
      fieldSeparator: 'Field separator',
      formattingOutput: 'Formatting & output',
      howGeneratedNameStringAssembled: 'How the generated name string is assembled.',
      noDefault: 'no default',
      none: 'none',
      notConfigured: 'Not configured',
      sample: 'Sample',
      sampleEmpty:
        'Nothing to sample yet: the first row has no values for the fields this pattern uses.',
      sampleIsPreview:
        'A preview. # and ? stand for characters filled in when a record gets its code.',
      selectPlatformsSchemaPropertiesSet:
        'Select platforms in Schema Properties to set per-channel limits.',
      standaloneUniqueIdGeneratedTaxonomy:
        'A standalone unique ID generated from taxonomy values (e.g. Brand + Year + sequence), separate from the concatenated name — a universal asset join key served via the API.',
      subfieldSeparator: 'Subfield separator',
      uniqueTrackingCode: 'Unique tracking code',
    },
    taxonomyActionMenu: {
      archive: 'Archive',
      archivingRetiresSchemaActiveUse:
        'Archiving retires this schema from active use. You can restore it later.',
      confirm: 'Confirm',
      delete: 'Delete',
      duplicate: 'Duplicate',
      edit: 'Edit',
      publish: 'Publish',
      publishingMakesVersionActiveNaming: 'Publishing makes this version the active naming schema.',
      removesSchemaListActionCannot:
        'This removes the schema from the list. This action cannot be undone.',
      taxonomyActions: 'Taxonomy actions',
      publishNamed: 'Publish “{{name}}”',
      archiveNamed: 'Archive “{{name}}”',
      deleteNamed: 'Delete “{{name}}”',
    },
    taxonomyCategories: {
      selectCategory: 'Select {{name}}',
      deleteCategoryTitle: 'Delete \u201c{{name}}\u201d?',
      deleteCategories_one: 'Delete {{count}} category',
      deleteCategories_other: 'Delete {{count}} categories',
      deleteCategoriesTitle_one: 'Delete {{count}} category?',
      deleteCategoriesTitle_other: 'Delete {{count}} categories?',
      fieldCount_one: '{{count}} field',
      fieldCount_other: '{{count}} fields',
      fieldsInWillMoveTo_one:
        '{{count}} field in “{{from}}” will move to “{{target}}” — none are deleted, and you can re-file them from the Fields tab.',
      fieldsInWillMoveTo_other:
        '{{count}} fields in “{{from}}” will move to “{{target}}” — none are deleted, and you can re-file them from the Fields tab.',
      fieldsWillMoveTo_one:
        '{{count}} field will move to “{{target}}” — none are deleted, and you can re-file them from the Fields tab.',
      fieldsWillMoveTo_other:
        '{{count}} fields will move to “{{target}}” — none are deleted, and you can re-file them from the Fields tab.',
      actions: 'Actions',
      addMonksflowStandardCategoriesRegistry:
        'Add the MonksFlow standard categories the registry is missing',
      addStandardCategories: 'Add standard categories',
      cancel: 'Cancel',
      clearSelection: 'Clear selection',
      createYourOwn: 'Create your own',
      deleteCategory: 'Delete category',
      fields: 'Fields',
      groupsYourFieldDefinitionsEach:
        'Groups for your field definitions. Each carries an icon and a position in the Add field picker. Start from the standard set — Geography, Media buy, Campaign, Creative and Targeting &amp; offer — or define your own.',
      icon: 'Icon',
      lastModified: 'Last modified',
      name: 'Name',
      newCategory: 'New category',
      noCategoriesYet: 'No categories yet',
      nothingUsesCategorySoNothing: 'Nothing uses this category, so nothing changes elsewhere.',
      nothingUsesTheseCategoriesSo: 'Nothing uses these categories, so nothing changes elsewhere.',
      organization: 'Organization',
      scope: 'Scope',
      searchCategories: 'Search categories…',
      searchCategories2: 'Search categories',
      selectAllCategories: 'Select all categories',
      workspace: 'Workspace',
    },
    taxonomyCategoryMutations: {
      categoryCreated: 'Category “{{name}}” created',
      addedStandardCategories_one: 'Added {{count}} standard category',
      addedStandardCategories_other: 'Added {{count}} standard categories',
      categoryRemovedFieldsMoved: 'Category removed — {{fields}} moved to “{{target}}”',
      deletedCategories_one: 'Deleted {{count}} category',
      deletedCategories_other: 'Deleted {{count}} categories',
      deletedCategoriesFieldsMoved: '{{deleted}} — {{fields}} moved to “{{target}}”',
      fieldCount_one: '{{count}} field',
      fieldCount_other: '{{count}} fields',
      categoryRemoved: 'Category removed',
      categoryUpdated: 'Category updated',
      failedAddStandardCategories: 'Failed to add standard categories',
      failedCreateCategory: 'Failed to create category',
      failedDeleteCategories: 'Failed to delete categories',
      failedRemoveCategory: 'Failed to remove category',
      failedUpdateCategory: 'Failed to update category',
      yourRegistryAlreadyHasEvery: 'Your registry already has every standard category',
    },
    taxonomyDetail: {
      markedOnFieldsTab_one:
        '{{count}} of these is marked on the Fields tab — switch to it to see it.',
      markedOnFieldsTab_other:
        '{{count}} of these are marked on the Fields tab — switch to it to see them.',
      newVersionDescription:
        'Creates an editable v{{draft}} draft copied from v{{head}}. The published version stays live until you publish the new one.',
      newVersionOf: 'New version of “{{name}}”',
      restoreVersionDescription:
        "Creates an editable v{{draft}} draft carrying v{{source}}'s fields and rules. Nothing is deleted — v{{head}} stays in history, and any schema pinned to it is unaffected.",
      restoreVersionTitle: 'Restore v{{version}}?',
      unpublishDescription:
        'Version {{version}} goes back to draft so you can edit it in place — no new version is created. It stops being the active naming schema until you publish again, and its list-bound columns follow their lists again rather than staying frozen at the values they were published with.',
      unpublishNamed: 'Unpublish “{{name}}”?',
      problemCount_one: '{{count}} problem',
      problemCount_other: '{{count}} problems',
      warningCount_one: '{{count}} warning',
      warningCount_other: '{{count}} warnings',
      allChangesSaved: 'All changes saved',
      backTaxonomy: 'Back to Taxonomy',
      clear: 'Clear',
      createVersion: 'Create version',
      exitFullScreen: 'Exit full screen',
      fields: 'Fields',
      fullScreen: 'Full screen',
      notTiedToAColumn: 'Not tied to a particular column:',
      newVersion: 'New version',
      noProblemsFound: 'No problems found.',
      notCheckedYet: 'Not checked yet',
      showDetails: 'Show details',
      validationDetails: 'Validation details',
      useDisplayValuesAsCodes: 'Use display values as codes',
      notSaved: 'Not saved',
      publish: 'Publish',
      publishNamed: 'Publish “{{name}}”',
      publishingMakesVersionActiveNaming: 'Publishing makes this version the active naming schema.',
      reloadLatest: 'Reload latest',
      restoreVersion: 'Restore version',
      retrySave: 'Retry',
      rules: 'Rules',
      saving: 'Saving…',
      editsStillOnScreenNextChange:
        'Your edits are still on screen, and the next change tries again on its own.',
      savingPausedSoYourCopy:
        'Saving is paused so your copy can’t overwrite theirs. Your edits are still on screen — copy anything you need before reloading, because reloading replaces them with the latest saved version.',
      schemaContent: 'Schema Content',
      newerSchemaVersionCreated: 'A newer version of this schema was created.',
      someoneElseEditedSchemaYour:
        'Someone else edited this schema — your recent changes are not saved',
      taxonomyAdministration: 'Taxonomy Administration',
      taxonomyCouldnTLoaded: 'This taxonomy couldn’t be loaded.',
      unpublish: 'Unpublish',
      validate: 'Validate',
      waitingSharedListsLoad: 'Waiting for shared lists to load…',
      yourChangesCouldNotSaved: 'Your changes could not be saved.',
      listOutOfScopeNotSaved_one:
        'Not saved: the list “{{lists}}” isn’t visible everywhere this schema is used. Unlink it, or link an organization list instead.',
      listOutOfScopeNotSaved_other:
        'Not saved: the lists {{lists}} aren’t visible everywhere this schema is used. Unlink them, or link organization lists instead.',
      viewingPastVersion: 'You’re viewing v{{number}} ({{status}}), a past version — read-only.',
      goToCurrentVersion: 'Go to current (v{{number}})',
      versionReadOnlyStartNewVersion:
        'This version is {{status}} and read-only. Start a new version to make changes — it copies this one’s fields and rules so you can edit from here.',
    },
    taxonomyFieldTemplateMutations: {
      nothingRestored: 'Nothing was restored',
      nothingRemoved: 'No fields were removed. They may already be gone.',
      restoreBlockedFields_one:
        "Couldn't restore {{count}} field: it was added to the library again",
      restoreBlockedFields_other:
        "Couldn't restore {{count}} fields: they were added to the library again",
      removedFieldNamed: 'Removed “{{name}}” from the library',
      removedFields_one: 'Removed {{count}} field from the library',
      removedFields_other: 'Removed {{count}} fields from the library',
      failedRemoveFields: "Couldn't remove the fields",
      undo: 'Undo',
      restoredFieldNamed: 'Restored “{{name}}”',
      restoredFields_one: 'Restored {{count}} field',
      restoredFields_other: 'Restored {{count}} fields',
      restoredFieldsBlocked_one:
        "{{restored}} · {{count}} couldn't be restored: it was added to the library again",
      restoredFieldsBlocked_other:
        "{{restored}} · {{count}} couldn't be restored: they were added to the library again",
      restoreBlockedNamed: "Couldn't restore “{{name}}”: it was added to the library again",
      failedRestore_one: "Couldn't restore the removed field",
      failedRestore_other: "Couldn't restore the removed fields",
      addedStandardFields_one: 'Added {{count}} standard field',
      addedStandardFields_other: 'Added {{count}} standard fields',
      failedAddField: 'Failed to add field',
      failedAddStandardFields: 'Failed to add standard fields',
      failedRemoveField: 'Failed to remove field',
      failedUpdateField: 'Failed to update field',
      fieldAddedLibrary: 'Field added to library',
      fieldUpdated: 'Field updated',
    },
    taxonomyFields: {
      removeFromLibrary: 'Remove from library',
      removeFieldTitle: 'Remove “{{name}}” from the library?',
      removeFields_one: 'Remove {{count}} field',
      removeFields_other: 'Remove {{count}} fields',
      removeFieldsTitle_one: 'Remove {{count}} field from the library?',
      removeFieldsTitle_other: 'Remove {{count}} fields from the library?',
      copyModelNote:
        "Fields are copied into a schema when added. Changing or removing one here doesn't affect schemas that already use it.",
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      selectField: 'Select {{name}}',
      actions: 'Actions',
      addStandardFields: 'Add standard fields',
      all: 'All',
      cancel: 'Cancel',
      category: 'Category',
      chooseWhichMonksflowStandardFields: 'Choose which MonksFlow standard fields to add',
      clearSelection: 'Clear selection',
      custom: 'Custom',
      editedStandard: 'Edited standard',
      fieldType: 'Field type',
      level: 'Level',
      name: 'Name',
      newField: 'New field',
      noReusableFieldsYet: 'No reusable fields yet',
      options: 'Options',
      organization: 'Organization',
      removesLibraryOnlySchemasAlready:
        'Removes it from the library only. Schemas that already use this field keep their own copy — nothing downstream changes.',
      removesThemLibraryOnlySchemas:
        'Removes them from the library only. Schemas already using these fields keep their own copies — nothing downstream changes.',
      saveFieldDefinitionOnceType:
        'Save a field definition once — its type, hierarchy level, validation and options — and drop it into any schema. Start from our standard marketing fields or define your own.',
      scope: 'Scope',
      searchFields: 'Search fields…',
      searchFields2: 'Search fields',
      selectAllFields: 'Select all fields',
      sharedList: 'shared list',
      standard: 'Standard',
      type: 'Type',
      workspace: 'Workspace',
    },
    taxonomyLayout: {
      defineVersionNamingSchemasKeep:
        'Define and version the naming schemas that keep campaign, creative and media names consistent across every market and platform.',
      groupsOrganiseYourFieldDefinitions: 'Groups that organise your field definitions',
      knowledge: 'Knowledge',
      reusableFieldDefinitionsYourSchemas: 'Reusable field definitions your schemas can pull from',
      reusableVocabulariesSharedAcrossSchemas: 'Reusable vocabularies shared across schemas',
      taxonomyAdministration: 'Taxonomy Administration',
    },
    taxonomyList: {
      deleteSchemas_one: 'Delete {{count}} schema',
      deleteSchemas_other: 'Delete {{count}} schemas',
      deleteSchemasTitle_one: 'Delete {{count}} schema?',
      deleteSchemasTitle_other: 'Delete {{count}} schemas?',
      everyVersionHistoryGoesThem:
        "Every version and its history goes with them. This can't be undone.",
    },
    taxonomyListDetail: {
      copyList: 'Copy list',
      copyListDone_one:
        'Copied the column names and {{count}} row. Paste them into New list in another environment.',
      copyListDone_other:
        'Copied the column names and {{count}} rows. Paste them into New list in another environment.',
      copyListBlankColumn: 'Column {{number}}',
      copyListFailed:
        "Couldn't copy the list. Check that the browser allows clipboard access and try again.",
      publishListTitle: 'Publish {{name}}',
      deleteListTitle: 'Delete \u201c{{name}}\u201d?',
      columnValue: '{{name}} value',
      couldnTLoadList: "This list couldn't be loaded.",
      listNotFound: 'This list no longer exists. It may have been deleted.',
      duplicateNeedsSave: 'Not copied: the latest edit is not saved yet.',
      pasteBlockOnlyValueAndCode:
        'Only Value and Code take a pasted block. Paste other columns one cell at a time.',
      pasteExtraColumnsLeftOut: 'Only Value and Code were pasted; the other columns were left out.',
      tryAgain: 'Try again',
      noSchemaUsesList_one:
        'No schema uses this list, so nothing breaks. Every version and all {{count}} option go with it.',
      noSchemaUsesList_other:
        'No schema uses this list, so nothing breaks. Every version and all {{count}} options go with it.',
      restoreVersionDescription:
        "Creates an editable v{{draft}} draft carrying v{{source}}'s options. Nothing is deleted — v{{head}} stays in history, and schemas pinned to it are unaffected.",
      restoreVersionTitle: 'Restore v{{version}}?',
      schemasStillBind_one:
        "{{count}} schema still binds a field to this list, so it can't be deleted. Unlink it there, and publish the schema again if its published version uses this list.",
      schemasStillBind_other:
        "{{count}} schemas still bind a field to this list, so it can't be deleted. Unlink it there, and publish again any schema whose published version uses this list.",
      usedBySchemas_one:
        'Used by {{count}} schema — changes published here propagate to every field that follows this list.',
      usedBySchemas_other:
        'Used by {{count}} schemas — changes published here propagate to every field that follows this list.',
      addRowStartBuildingVocabulary: 'Add an option to start building this vocabulary.',
      allChangesSaved: 'All changes saved',
      branchesEditableDraftCurrentVersion:
        'Branches an editable draft from the current version. Schemas pinned to older versions are unaffected.',
      cancel: 'Cancel',
      createVersion: 'Create version',
      deleteList: 'Delete list',
      duplicate: 'Duplicate',
      listActions: 'List actions',
      loading: 'Loading…',
      newVersion: 'New version',
      noOptionsYet: 'No options yet.',
      notSaved: 'Not saved',
      notYetUsedAnySchema:
        'Not yet used by any schema. Bind a field to this list from the schema builder.',
      createNewVersion: 'Create new version',
      filledEmptyCells_one: 'Filled {{count}} empty cell.',
      filledEmptyCells_other: 'Filled {{count}} empty cells.',
      publish: 'Publish',
      publishingFreezesVersionSchemasFollow:
        'Publishing freezes this version. Schemas that follow this list pick up the new options immediately.',
      reloadLatest: 'Reload latest',
      removeRow: 'Remove row',
      restoreVersion: 'Restore version',
      retrySave: 'Retry',
      saving: 'Saving…',
      savingPausedSoYourCopy:
        'Saving is paused so your copy can’t overwrite theirs. Your edits are still on screen — copy anything you need before reloading, because reloading replaces them with the latest saved version.',
      newerVersionCreated: 'A newer version of this list was created.',
      someoneElseEditedListYour:
        'Someone else edited this list — your recent changes are not saved',
      versionPublishedReadOnlyCreate:
        ' This version is published and read-only — create a new version to edit.',
      yourChangesCouldNotSaved: 'Your changes could not be saved.',
      history: 'History',
      close: 'Close',
      options: 'Options',
      addOption: 'Add option',
      pasteOptions: 'Paste options',
      fillEmptyCodes: 'Fill empty codes',
      listNameRequired: 'List name is required.',
      valueColumn: 'Value',
      codeColumn: 'Code',
      editList: 'Edit list',
      viewingPastVersion:
        'Viewing v{{number}} — a past version, read-only. Schemas pinned to it still see exactly these options.',
    },
    taxonomyListMutations: {
      addedStandardLists_one: 'Added {{count}} standard list',
      addedStandardLists_other: 'Added {{count}} standard lists',
      deletedLists_one: 'Deleted {{count}} list',
      deletedLists_other: 'Deleted {{count}} lists',
      deletedListsBlocked: '{{deleted}} · {{blocked}} kept, still used by a schema',
      couldNotDeleteListMay: 'Could not delete — the list may still be in use by a schema',
      failedAddStandardLists: 'Failed to add standard lists',
      failedCreateList: 'Failed to create list',
      failedCreateVersion: 'Failed to create version',
      failedDeleteLists: 'Failed to delete lists',
      failedDuplicateList: 'Failed to duplicate list',
      failedSaveList: 'Failed to save list',
      failedUpdateList: 'Failed to update list',
      listCreated: 'List created',
      listDeleted: 'List deleted',
      listUpdated: 'List updated',
      newVersionCreated: 'New version created',
      yourLibraryAlreadyHasEvery: 'Your library already has every standard list',
      createdNamed: 'Created “{{name}}”',
    },
    taxonomyLists: {
      organization: 'Organization',
      workspace: 'Workspace',
      sharedModelNote:
        "Lists are shared. Schemas follow their changes, so a list in use can't be deleted.",
      selectList: 'Select {{name}}',
      deleteLists_one: 'Delete {{count}} list',
      deleteLists_other: 'Delete {{count}} lists',
      deleteListsTitle_one: 'Delete {{count}} list?',
      deleteListsTitle_other: 'Delete {{count}} lists?',
      optionCount_one: '{{count}} option',
      optionCount_other: '{{count}} options',
      schemaCount_one: '{{count}} schema',
      schemaCount_other: '{{count}} schemas',
      actions: 'Actions',
      addStandardLists: 'Add standard lists',
      cancel: 'Cancel',
      chooseWhichMonksflowStandardLists: 'Choose which MonksFlow standard lists to add',
      clearSelection: 'Clear selection',
      columns: 'Columns',
      createYourOwn: 'Create your own',
      custom: 'Custom',
      everyVersionAllOptionsGo: 'Every version and all options go with them.',
      lastModified: 'Last modified',
      listReusableSetOptionsLike:
        'A list is a reusable set of options — like Region or Channel — defined once and shared by every schema that needs it. Update it here and all of them stay in sync.',
      name: 'Name',
      newList: 'New list',
      noListsYet: 'No lists yet',
      options: 'Options',
      scope: 'Scope',
      searchLists: 'Search lists…',
      searchLists2: 'Search lists',
      selectAllLists: 'Select all lists',
      standard: 'Standard',
      status: 'Status',
      type: 'Type',
      unused: 'Unused',
      used: 'Used by',
      version: 'Version',
      willBeKeptStillUsed_one: '{{count}} will be kept — still used by a schema',
      willBeKeptStillUsed_other: '{{count}} will be kept — still used by a schema',
    },
    exportWarning: {
      title: 'Before you export',
      description:
        'Every record in this dataset will be exported. Here is what to know before the file downloads.',
      incomplete_one:
        '1 of {{total}} rows is missing a required value, or holds one its field does not allow. It is exported as it is, not left out.',
      incomplete_other:
        '{{count}} of {{total}} rows are missing a required value, or hold one their field does not allow. They are exported as they are, not left out.',
      rules:
        'This schema uses conditional rules. The generated-name column recalculates as you edit the sheet, but a spreadsheet formula cannot apply rules, so it may differ from the app on rows a rule affects.',
      nameNotLive:
        'The generated-name column will hold a fixed value rather than a live calculation, because part of the name comes from a linked schema a spreadsheet cannot resolve. Editing a cell will not update it.',
      unsaved: 'Unsaved changes are not included. The file contains what has been saved.',
      confirm: 'Export anyway',
    },
    grid: {
      preview: 'Preview',
      recordCount_one: '{{count}} record',
      recordCount_other: '{{count}} records',
      selected_one: '{{count}} selected',
      selected_other: '{{count}} selected',
      // Every edited row is held back, so the button promises nothing rather than
      // "Save 0 changes". The reason beside it says which rows and why.
      saveDirty_zero: 'Save',
      saveDirty_one: 'Save {{count}} change',
      saveDirty_other: 'Save {{count}} changes',
      saved: 'All changes saved',
      duplicate: 'Duplicate',
      clearAction: 'Clear',
      deleteAction: 'Delete',
      clear: 'Clear',
      addRecords: 'Add records',
      export: 'Export',
      rowNumber: 'Row',
      noMatchingOptions: 'No matching options',
      copyName: 'Copy generated name',
      nameCopied: 'Name copied',
      fillColumnLabel: 'Fill this column',
      fillFromFirst: 'Fill down from first row',
      fillSetAllRows: 'Set all rows to',
      fillSetSelectedRows: 'Set selected rows to',
      fillAlreadySet: 'Every row in scope already holds that value.',
      fillNothingToCopy: 'The first row has nothing in this column to copy down.',
      fillHiddenByRule_one: '1 row skipped: a rule hides this column for it.',
      fillHiddenByRule_other: '{{count}} rows skipped: a rule hides this column for them.',
      fillRefused_one: '1 row skipped: that value is not among its allowed options.',
      fillRefused_other: '{{count}} rows skipped: that value is not among their allowed options.',
      saveBlockedPattern_one:
        '1 edited row holds a value its field does not allow and will not be saved.',
      saveBlockedPattern_other:
        '{{count}} edited rows hold a value their field does not allow and will not be saved.',
      saveBlockedIncomplete_one: '1 edited row is missing a required value and will not be saved.',
      saveBlockedIncomplete_other:
        '{{count}} edited rows are missing a required value and will not be saved.',
      saveBlockedDuplicate_one:
        '1 edited row generates a name another row already has and will not be saved.',
      saveBlockedDuplicate_other:
        '{{count}} edited rows generate a name another row already has and will not be saved.',
      duplicatesRow: 'This name is already used by row {{row}}, so this row will not be saved.',
      // Two sentences rather than one vaguer sentence. A row can keep a name in
      // the saved data while displaying a different one, and a reader sent to
      // that row without being told so concludes the marker is broken.
      duplicatesRowRetained:
        'Row {{row}} still holds this name in the saved data, even though it now shows a ' +
        'different one, so this row will not be saved.',
      requiredEmpty: 'This field is required for this record.',
      emptyTitle: 'No records yet',
      emptyDescription: 'Add records to start generating names from this schema.',
      selectAllRecords: 'Select all records',
      clearSelection: 'Clear selection',
      selectRecord: 'Select record {{number}}',
      cellFromList: 'These options come from a shared list. Edit them in the list itself.',
      cancel: 'Cancel',
      pasteRefused_one:
        '1 pasted value was not one of the allowed options for its column and was skipped ({{example}}).',
      pasteRefused_other:
        '{{count}} pasted values were not among the allowed options for their columns and were skipped (e.g. {{example}}).',
      duplicateNeedsChange_one:
        'Change a value on the copy before saving — as an exact copy it would generate the same name as the original, and names have to be unique.',
      duplicateNeedsChange_other:
        'Change a value on each copy before saving — as exact copies they would generate the same names as their originals, and names have to be unique.',
      deleteBlockedColumn: "Generated columns are filled in for you, so they can't be cleared.",
      deleteHiddenByRule:
        "A rule is hiding this cell for that record, so it can't be cleared. Change what the rule depends on instead.",
      pasteBlockedColumns_one:
        '1 pasted value landed on a generated column and was skipped. Those columns are filled in for you.',
      pasteBlockedColumns_other:
        '{{count}} pasted values landed on generated columns and were skipped. Those columns are filled in for you.',
      pasteHiddenByRule_one:
        '1 pasted value landed on a cell a rule is hiding for that record and was skipped. Change what the rule depends on to fill it in.',
      pasteHiddenByRule_other:
        '{{count}} pasted values landed on cells a rule is hiding for those records and were skipped. Change what the rules depend on to fill them in.',
      pasteClippedRows_one:
        '1 pasted row did not fit and was not added. Add more records first, then paste again.',
      pasteClippedRows_other:
        '{{count}} pasted rows did not fit and were not added. Add more records first, then paste again.',
      pasteClippedColumns_one: '1 pasted column did not fit and was left out.',
      pasteClippedColumns_other: '{{count}} pasted columns did not fit and were left out.',
      generateCodes: 'Generate codes',
      codeDryRun: 'A preview. The # and ? parts are allocated when you generate the code.',
      codeDryRunLabel:
        'Preview of the code {{code}}. No code has been generated for this record yet.',
      codeConfirmTitle: 'Generate tracking codes?',
      codeConfirmBody_one:
        'This permanently uses 1 of the {{remaining}} tracking codes this schema has left. A code cannot be released or reused, and it stays fixed even if you edit the record afterwards.',
      codeConfirmBody_other:
        'This permanently uses {{count}} of the {{remaining}} tracking codes this schema has left. A code cannot be released or reused, and it stays fixed even if you edit the record afterwards.',
      codeConfirmAction: 'Generate',
      confirmClearTitle_one: 'Empty {{count}} row?',
      confirmClearTitle_other: 'Empty {{count}} rows?',
      confirmClearBody:
        'This empties every value in the selected rows and cannot be undone. The rows themselves stay, so any tracking code already generated for them can still be reused.',
      confirmClearAction: 'Yes, empty them',
      confirmDeleteTitle_one: 'Delete {{count}} row?',
      confirmDeleteTitle_other: 'Delete {{count}} rows?',
      confirmDeleteBody:
        'This removes the selected rows and cannot be undone. Any tracking code already generated for them cannot be reused, and it still counts towards the limit for this schema.',
      confirmDeleteAction: 'Yes, delete them',
      codesGenerated_one: 'Generated and saved {{count}} tracking code.',
      codesGenerated_other: 'Generated and saved {{count}} tracking codes.',
      codesSkipped_one: '{{count}} record did not get a code: {{reasons}}',
      codesSkipped_other: '{{count}} records did not get a code: {{reasons}}',
      codeSkipReason: {
        record_incomplete: 'a column the code is built from is empty',
        record_not_in_dataset: 'the record is no longer in this taxonomy',
        code_mint_failed: 'the code could not be generated',
        unknown: 'an unexpected problem',
      },
      codesSkippedIncomplete_one:
        '1 record has no code yet because a column its code is built from is empty. Fill it in and generate again.',
      codesSkippedIncomplete_other:
        '{{count}} records have no code yet because a column their code is built from is empty. Fill them in and generate again.',
      codesNeedSave: 'Save your changes before generating codes.',
      codesTooMany: 'Select at most {{max}} records to generate codes for.',
      codesAlreadyGenerated: 'Every selected record already has a code.',
      breaksPattern: 'This value does not match the pattern this field requires ({{pattern}}).',
      conflictBanner_one:
        '{{count}} record changed somewhere else while you were editing, so it was not saved. Reload to see the newer version.',
      conflictBanner_other:
        '{{count}} records changed somewhere else while you were editing, so they were not saved. Reload to see the newer versions.',
      unsavedTitle: 'Leave without saving?',
      unsavedBody_one: 'You have {{count}} unsaved change. Leaving now discards it.',
      unsavedBody_other: 'You have {{count}} unsaved changes. Leaving now discards them.',
      leave: 'Leave',
      stay: 'Keep editing',
    },
    generationDetail: {
      renameTaxonomy: 'Rename taxonomy',
      schemaSuffix: '({{name}} v{{version}})',
      notFoundTitle: 'Taxonomy not found',
      notFoundDescription: 'It may have been deleted, or you may not have access to it.',
      schemaErrorTitle: "Couldn't load the schema",
      recordsErrorTitle: "Couldn't load the records",
      loadErrorDescription: 'Check your connection and try again.',
      tryAgain: 'Try again',
      missingVersionTitle: 'This schema version is unavailable',
      missingVersionDescription:
        'The version this taxonomy was built against can no longer be read, so its columns cannot be shown.',
      exportFileName: '{{dataset}} ({{schema}} - v{{version}})',
      exportFileNameInCampaign: '{{campaign}} - {{dataset}} ({{schema}} - v{{version}})',
    },
    generationList: {
      title: 'Taxonomy Generation',
      tileDescription: 'Manually create and export taxonomy naming',
      searchPlaceholder: 'Search taxonomies by name or schema',
      newTaxonomy: 'New taxonomy',
      columnTaxonomy: 'Taxonomy',
      columnRecords: 'Records',
      columnSchema: 'Schema',
      columnUpdated: 'Last updated',
      columnUpdatedBy: 'Last updated by',
      rowActions: '{{name}} actions',
      edit: 'Edit',
      duplicate: 'Duplicate',
      delete: 'Delete',
      cancel: 'Cancel',
      create: 'Create',
      name: 'Name',
      namePlaceholder: 'Enter taxonomy name',
      nameTaken: 'A taxonomy with this name already exists for this schema.',
      description: 'Description',
      descriptionPlaceholder: 'What is this set of records for? (optional)',
      schema: 'Schema',
      selectSchema: 'Select schema',
      schemaOption: '{{name}} v{{version}}',
      schemaSummary_one: '{{name}} · v{{version}} · {{count}} field',
      schemaSummary_other: '{{name}} · v{{version}} · {{count}} fields',
      schemaSummaryWithMarkets_one: '{{name}} · v{{version}} · {{count}} field · {{markets}}',
      schemaSummaryWithMarkets_other: '{{name}} · v{{version}} · {{count}} fields · {{markets}}',
      schemaSummaryUnavailable: '{{name}} · v{{version}} · field count unavailable',
      schemaSummaryUnavailableWithMarkets:
        '{{name}} · v{{version}} · field count unavailable · {{markets}}',
      unknownSchema: 'Unknown schema',
      unknownUser: 'Unknown',
      noPublishedSchemas:
        'No published schemas yet. A schema has to be published before you can generate names from it.',
      emptyTitle: 'No taxonomies yet',
      emptyDescription: 'Create one to start generating names from a published schema.',
      noResultsTitle: 'No taxonomies match your search',
      noResultsDescription: 'Try a different name or schema.',
      errorTitle: 'Couldn’t load taxonomies',
      errorDescription: 'Something went wrong while loading taxonomies.',
      tryAgain: 'Try again',
      // English CLDR has no `zero` category, but i18next honours an explicit
      // `_zero` at count 0 - so an empty taxonomy reads as one rather than
      // "Its 0 records will be deleted too."
      deleteBody_zero: 'This taxonomy has no records. This cannot be undone.',
      deleteBody_one: 'Its {{count}} record will be deleted too. This cannot be undone.',
      deleteBody_other: 'Its {{count}} records will be deleted too. This cannot be undone.',
    },
    import: {
      schemaExisting: 'Existing schema',
      schemaNew: 'New from a spreadsheet',
      fillFromSpreadsheet: 'Fill from a spreadsheet (optional)',
      dropTitle: 'Drop a naming spreadsheet here',
      dropCaption: 'XLSX or CSV, up to 10 MB',
      dropButton: 'Choose file',
      dropTitleDocument: 'Drop a naming spreadsheet or PDF here',
      dropCaptionDocument: 'XLSX or CSV up to 10 MB, or PDF up to 20 MB',
      tooLargeDocument: 'That file is larger than 20 MB.',
      wrongTypeDocument: 'Only .xlsx, .csv and .pdf files can be imported.',
      chosenFile: '{{name}} is ready to read',
      removeFile: 'Remove {{name}}',
      tooLarge: 'That file is larger than 10 MB.',
      wrongType: 'Only .xlsx and .csv spreadsheets can be imported.',
      read: 'Read spreadsheet',
      startFailed: 'Could not start the import',
    },
    schemaAgent: {
      name: 'Schema agent',
      empty:
        'Ask me to change this schema: add or reorder its parts, change what a part accepts, or add a value to a list. Or give me a naming spreadsheet or PDF and I build the schema from it.',
      fromFile: 'Build this schema from {{fileName}}.',
      fromFileThenTaxonomy:
        'Build this schema from {{fileName}}, then make a taxonomy of its rows.',
      fromFileThenTaxonomyIn:
        'Build this schema from {{fileName}}, then make a taxonomy of its rows in the {{campaign}} campaign.',
      prompts: {
        addField: 'Add a field to this schema',
        addValue: 'Add a value to a list',
        publish: 'Publish the draft',
      },
    },
    agent: {
      name: 'Taxonomy agent',
      empty:
        'Ask me to change this taxonomy: its rows, its name and campaign, or its schema. Or give me a spreadsheet and I bring its rows in.',
      fromFile: 'Bring the rows of {{fileName}} into this taxonomy.',
      prompts: {
        addRows: 'Add rows for a new market',
        addColumn: 'Add a column to the schema',
        rename: 'Rename this taxonomy',
      },
      tools: {
        readTaxonomy: 'Read the taxonomy',
        updateRecords: 'Edit rows',
        addRecords: 'Add rows',
        deleteRecords: 'Delete rows',
        generateTrackingCodes: 'Generate tracking codes',
        updateTaxonomy: 'Rename or refile',
        readSchema: 'Read the schema',
        editSchemaDraft: 'Edit the schema draft',
        editListValues: 'Edit a list',
        publishSchema: 'Publish the schema',
        moveToSchemaVersion: 'Move to a schema version',
        surveyWorkbook: 'Survey the file',
        readRange: 'Read cells',
        readFormulas: 'Read formulas',
        sampleColumn: 'Sample a column',
        findLibraryLists: 'Find library lists',
        createList: 'Create a list',
        checkNames: 'Check the names',
        createTaxonomy: 'Create a taxonomy',
        importRows: 'Bring rows in',
      },
    },
    generationMutations: {
      created: 'Taxonomy created',
      deleted: 'Taxonomy deleted',
      duplicated:
        'Taxonomy duplicated. Its records kept their values, and their names will be generated again as you edit them.',
      failedAddRecords: 'Failed to add records',
      failedClear: 'Failed to clear records',
      failedCreate: 'Failed to create taxonomy',
      failedDelete: 'Failed to delete taxonomy',
      failedDeleteRecords: 'Failed to delete records',
      nameTakenNamed: 'A taxonomy called "{{name}}" already exists.',
      failedDuplicate: 'Failed to duplicate taxonomy',
      failedExport: 'Failed to export records',
      failedSave: 'Failed to save records',
      failedRename: 'Failed to rename taxonomy',
      codesFailedRetryIsFree:
        '{{detail}} If a code was already issued for a record, generating again returns that same code and does not use another.',
      failedGenerateCodes: 'Failed to generate tracking codes',
    },
    taxonomyMutations: {
      deletedSchemas_one: 'Deleted {{count}} schema',
      deletedSchemas_other: 'Deleted {{count}} schemas',
      couldNotGenerateSuggestionsPlease: 'Could not generate suggestions. Please try again.',
      failedCreateSchema: 'Failed to create schema',
      failedCreateVersion: 'Failed to create version',
      failedDeleteSchema: 'Failed to delete schema',
      failedDeleteSchemas: 'Failed to delete schemas',
      failedDuplicateSchema: 'Failed to duplicate schema',
      failedSaveChanges: 'Failed to save changes',
      failedUpdateStatus: 'Failed to update status',
      newVersionCreated: 'New version created',
      schemaCreated: 'Schema created',
      schemaDeleted: 'Schema deleted',
      statusUpdated: 'Status updated',
      createdNamed: 'Created “{{name}}”',
    },
    taxonomyReasonModal: {
      cancel: 'Cancel',
      explainWhyRecordedAuditTrail: 'Explain why — recorded in the audit trail',
      reason: 'Reason',
    },
    taxonomyStates: {
      addSchema: 'Add schema',
      defineVersionNamingSchemas:
        'Define and version the naming schemas that keep campaign, creative and media names consistent across every market and platform.',
      clearFilters: 'Clear filters',
      couldnTLoadCategories: 'Couldn’t load categories',
      couldnTLoadFields: 'Couldn’t load fields',
      couldnTLoadLists: 'Couldn’t load lists',
      couldnTLoadSchemas: 'Couldn’t load schemas',
      // Whole sentences per tab rather than a noun interpolated into a shared
      // frame: the noun's article and inflection depend on the sentence, so a
      // frame cannot be translated. See the i18n convention doc.
      noCategoriesFound: 'No categories found',
      noCategoriesMatchYourSearch: 'No categories match your search. Try adjusting it.',
      noFieldsFound: 'No fields found',
      noFieldsMatchYourSearch: 'No fields match your search. Try adjusting it.',
      noListsFound: 'No lists found',
      noListsMatchYourSearch: 'No lists match your search. Try adjusting it.',
      noSchemasFound: 'No schemas found',
      taxonomy: 'Taxonomy',
      noSchemasMatchYourCurrent:
        'No schemas match your current search and filters. Try adjusting them.',
      somethingWentWrongWhileLoading: 'Something went wrong while loading taxonomies.',
      tryAgain: 'Try again',
    },
    taxonomyStatusBadge: {
      archived: 'Archived',
      draft: 'Draft',
      published: 'Published',
    },
    taxonomyTable: {
      selectSchema: 'Select {{name}}',
      actions: 'Actions',
      clearSelection: 'Clear selection',
      lastModified: 'Last modified',
      market: 'Market',
      name: 'Name',
      org: 'Org',
      platforms: 'Platforms',
      scope: 'Scope',
      selectAllSchemas: 'Select all schemas',
      status: 'Status',
      version: 'Version',
      workspace: 'Workspace',
    },
    taxonomyTabs: {
      categories: 'Categories',
      fields: 'Fields',
      lists: 'Lists',
      schemas: 'Schemas',
      taxonomySections: 'Taxonomy sections',
    },
    taxonomyToolbar: {
      addSchema: 'Add schema',
      deleteSchemas_one: 'Delete {{count}} schema',
      deleteSchemas_other: 'Delete {{count}} schemas',
      searchSchemas: 'Search schemas…',
      searchSchemasName: 'Search schemas by name',
    },
    trackingCodeComposer: {
      /**
       * Named in terms of what a user loses, not what the system does. "The key
       * changes" means nothing to them; "a code you have already handed out stops
       * matching" is the consequence they can act on.
       */
      editingAffectsMintedCodes_one:
        'This schema has issued {{count}} tracking code so far. If it came from this pattern, changing which fields the pattern reads means the asset it named may be given a second code rather than matching the one it has.',
      editingAffectsMintedCodes_other:
        'This schema has issued {{count}} tracking codes so far. If any came from this pattern, changing which fields the pattern reads means an asset named before may be given a second code rather than matching the one it has.',
      date: 'Date',
      field: 'Field',
      random: 'Random',
      sequence: 'Sequence',
      text: 'Text',
      addPartsBuildCode: 'Add parts to build the code…',
      addSequenceRandomPartKeep:
        'Add a Sequence (or Random) part to keep each generated code unique.',
      alphanumeric: 'Alphanumeric',
      cancel: 'Cancel',
      code: 'Code',
      configureVariable: 'Configure variable',
      eG: 'e.g. - or _',
      eGAssetTrackingId: 'e.g. Asset Tracking ID',
      length: 'Length',
      moveDown: 'Move down',
      moveUp: 'Move up',
      name: 'Name',
      numeric: 'Numeric',
      pattern: 'Pattern',
      randomChars: 'random chars',
      removePart: 'Remove part',
      savePattern: 'Save pattern',
      selectField: 'Select field',
      value: 'Value',
    },
    transformOptions: {
      lowercase: 'lowercase',
      none: 'None',
      trimWhitespace: 'Trim whitespace',
      uppercase: 'UPPERCASE',
    },
    useResolvedListValues: {
      boundColumnNoLongerExists: 'The bound column no longer exists on this list',
      listUnavailable: 'List unavailable',
      loading: 'Loading…',
      unknownList: 'Unknown list',
      versionNotFound: 'Version not found',
    },
    validateSchema: {
      ruleDeadField: 'Rule {{index}} references a column that no longer exists.',
      longestNameOverLimit:
        'The longest name this schema can produce is {{length}} characters — {{overBy}} over {{platform}}’s {{limit}}.',
      anotherFieldCalled: 'Another field is also called “{{name}}”.',
      codeAlreadyUsed: 'Code “{{code}}” is already used by another value in this field.',
      codeHasDelimiter: 'Code “{{code}}” contains the delimiter “{{delimiter}}”.',
      codeHasNoValue: 'Code “{{code}}” has no display value.',
      codeHasSpace: 'Code “{{code}}” contains a space.',
      duplicateValue: '“{{value}}” appears more than once in this field.',
      listBindingBroken: 'Shared list binding is broken — {{reason}}.',
      patternLiteralHasDelimiter: 'The literal “{{text}}” contains the separator “{{delimiter}}”.',
      patternValueHasDelimiter:
        'This pulls “{{field}}” display values, and “{{value}}” contains a separator.',
      listDuplicateCode_one: '“{{list}}” gives more than one option the code “{{code}}”.',
      listDuplicateCode_other:
        '“{{list}}” reuses {{count}} codes across more than one option, including “{{code}}”.',
      listValueHasNoCode_one: '“{{list}}” leaves “{{value}}” without a code.',
      listValueHasNoCode_other:
        '“{{list}}” leaves {{count}} options without a code, including “{{value}}”.',
      noDateTokens: '“{{format}}” has no date tokens, so it emits itself verbatim.',
      outputMissingColumn: 'Output “{{name}}” references a column that no longer exists.',
      ruleSetsMissingValue:
        'Rule {{rule}} sets “{{value}}”, which is no longer an option in “{{field}}”.',
      ruleTestsMissingValue:
        'Rule {{rule}} tests for “{{value}}”, which is no longer an option in “{{field}}”.',
      useTokensLike: 'Use tokens like {{mask}}, YYMMDD or MMMYY.',
      valueFailsPattern: '“{{value}}” doesn’t match this field’s own validation pattern.',
      valueHasNoCode: '“{{value}}” has no code.',
      valueOverCap: 'This value is {{length}} characters, over the {{cap}}-character cap.',
      addFieldGetStarted: 'Add a field to get started.',
      addValuesBindColumnShared: 'Add values, or bind the column to a shared list.',
      blankCodeCellListFalls:
        'A blank code cell in the list falls back to the display value. Give that row a code.',
      listHasNoCodesUseDisplay:
        'The list has no codes at all. Use its display values as codes, or add codes to the list.',
      listNowHasCodes:
        '“{{list}}” has a code column, but this field uses its display values as codes.',
      listNowHasCodesHint:
        'To use the codes, open the column menu, choose Edit list binding and pick the code column.',
      listColumnNowHasCodes:
        '“{{list}}” has values in its {{column}} column, but this field uses its display values as codes.',
      listColumnNowHasCodesHint:
        'To use {{column}} as the codes, open the column menu, choose Edit list binding and pick it as the Output code column.',
      branchCanNeverFire: 'That branch can never fire.',
      branchWillOfferValueNothing: 'The branch will offer a value nothing can select.',
      inlineCodeCannotHoldSpace:
        'A code typed into this column cannot hold a space. A code from a shared list can.',
      detachParentDelete: 'Detach it from its parent, or delete it.',
      dropdownHasNoOptionsSo: 'This dropdown has no options, so there is nothing to pick.',
      duplicateOptionsIndistinguishablePicker:
        'Duplicate options are indistinguishable in the picker.',
      editOutputDropReplaceMissing: 'Edit the output and drop or replace the missing part.',
      editPatternDropReplaceMissing: 'Edit the pattern and drop or replace the missing part.',
      fieldSValidationPatternIsn:
        'This field’s validation pattern isn’t a valid expression, so nothing enforces it.',
      fixPatternClearUnenforceableRule:
        'Fix the pattern or clear it — an unenforceable rule is worse than none.',
      generatingNameFallsBackDisplay:
        'Generating a name falls back to the display value, spaces and all.',
      generatingNameValueWillRejected:
        'Generating a name with this value will be rejected by the API.',
      linkedColumnHasNoTarget:
        'This linked column has no target schema, so it resolves to nothing.',
      nothingCanSelectRowGive: 'Nothing can select this row — give it a value or clear the code.',
      openPatternComposerAddLeast: 'Open the pattern composer and add at least one part.',
      openRulesTabRepointRemove: 'Open the Rules tab and repoint or remove that branch.',
      patternReferencesColumnNoLonger: 'Its pattern references a column that no longer exists.',
      pickSchemaPullsJoinKey: 'Pick the schema it pulls its join key from.',
      rePointBindingLiveList:
        'Re-point the binding at a live list and column, or unlink the field.',
      refusedBeforeAnyPatternApplied:
        'It is refused before any pattern is applied, so generation will reject it.',
      schemaHasNoFieldsYet: 'This schema has no fields yet, so it cannot generate a name.',
      shortenCodesDateFormatsRaise:
        'Shorten codes or date formats, or raise the limit in Schema settings.',
      subfieldSParentColumnNo: 'This subfield’s parent column no longer exists.',
      twoColumnsOneNameMake:
        'Two columns with one name make rules and the data dictionary ambiguous.',
      twoValuesSharingCodeMake:
        'Two values sharing a code make the generated name impossible to read back. Fix it in the list.',
      twoValuesSharingCodeMake2:
        'Two values sharing a code make the generated name impossible to read back.',
      variableColumnHasNoPattern: 'This variable column has no pattern, so it generates nothing.',
      pullCodeInsteadRenameValue: 'Pull the code instead, or rename the value.',
      changeCodeOrSeparatorSettings: 'Change the code, or change the separator in Schema settings.',
      editPatternRemoveSeparatorLiteral:
        'Edit the pattern and remove the separator from that literal.',
    },
    versionDiffModal: {
      showChangesGroup: 'Show changes',
      changeCount_one: '{{count}} change',
      changeCount_other: '{{count}} changes',
      added: 'added',
      added2: 'Added',
      all: 'All',
      blank: '(blank)',
      compareVersions: 'Compare versions',
      done: 'Done',
      fieldsAdded: 'Fields added',
      fieldsModified: 'Fields modified',
      fieldsRemoved: 'Fields removed',
      initial: 'Initial',
      initialEmpty: 'Initial (empty)',
      modified: 'modified',
      modified2: 'Modified',
      noChanges: 'No changes',
      noChangesMatchFilter: 'No changes match this filter.',
      noDifferencesBetweenTheseVersions: 'No differences between these versions.',
      otherChanges_one: '{{count}} other change',
      otherChanges_other: '{{count}} other changes',
      none: '(none)',
      properties: 'Properties',
      removed: 'removed',
      removed2: 'Removed',
      rulesAdded: 'Rules added',
      rulesModified: 'Rules modified',
      rulesRemoved: 'Rules removed',
      searchFields: 'Search fields…',
      searchFieldsLabel: 'Search changed fields and rules',
      selectTwoVersionsCompare: 'Select two versions to compare.',
      versionWithStatus: 'v{{number}} · {{status}}',
      ruleCount_one: '{{count}} rule',
      ruleCount_other: '{{count}} rules',
      propertyCount_one: '{{count}} property',
      propertyCount_other: '{{count}} properties',
    },
    versionMenu: {
      compare: 'Compare',
      current: 'Current',
      finishPublishCurrentDraftFirst: 'Finish or publish the current draft first.',
      history: 'History',
      newVersion: 'New version',
      restoreVersion: 'Restore this version',
      versioning: 'Versioning',
      versionNumber: 'Version {{number}}',
    },
  },
} as const;
